// Type definitions
export interface TherapistPricing {
  standardFees: {
    individual?: {
      amount: string;
      currency: string;
      location?: "India" | "International";
      duration?: string;
    };
    couples?: {
      amount: string;
      currency: string;
      location?: "India" | "International";
      duration?: string;
    };
    family?: {
      amount: string;
      currency: string;
      location?: "India" | "International";
      duration?: string;
    };
  }[];
  slidingScale?: {
    range?: {
      min: string;
      max: string;
    };
    fixedAmount?: string;
    availableFor?: string[];
    slots?: number;
  };
  // Fields for filtering
  priceRange: "0-500" | "500-1000" | "1000-1500" | "1500-2000" | "2000+";
  highestCharge: string;
}

// Type definitions
export interface Availability {
  days: string;
  hours: string;
}

export interface Qualifications {
  degree: string;
  institution: string;
}

export interface ReviewsType {
  client?: string;
  review?: string;
}

export interface Therapist {
  id: string;
  displayId: string; // For showing "Therapist 1, 2" etc.
  name: string;
  pronouns: string;
  qualifications: Qualifications[];
  avatar: string;
  bio: string;
  specialization: string[];
  experience: number;
  // Standardized experience for filtering
  experienceRange:
    | "Less than 1 year"
    | "1-2 years"
    | "2-3 years"
    | "3-4 years"
    | "4+ years";
  languages: string[];
  availability: Availability[];
  contact: {
    email: string;
    phone?: string;
    linkedin?: string;
    instagram?: string;
    location?: string;
  };
  pricing: TherapistPricing;
  expertise?: string[];
  serviceIds: string[]; // Reference to services they provide
  concerns: string[]; // Added field for concern-based filtering
  directConcernsTags?: string[];
  blogs?: string[];
  probono?: boolean;
  reviews?: ReviewsType[];
}

export interface ServiceProcedure {
  step: number;
  description: string;
  duration: string;
}

export interface Service {
  id: string;
  slug: string;
  name: string;
  description: string;
  targetAudience: string[];
  duration: string;
  sessionsPerMonth: string;
  procedures: ServiceProcedure[];
  therapistIds: string[]; // Reference to therapists instead of embedding
  pricing: {
    basePrice: number;
    currency: string;
  };
  heroImage: string;
}

// // Helper function to determine experience range
// const getExperienceRange = (years: number): Therapist["experienceRange"] => {
//   if (years < 1) return "Less than 1 year";
//   if (years <= 2) return "1-2 years";
//   if (years <= 4) return "3-4 years";
//   return "4+ years";
// };

// // Helper function to determine price range
// const getPriceRange = (
//   highestPrice: number
// ): TherapistPricing["priceRange"] => {
//   if (highestPrice <= 500) return "0-500";
//   if (highestPrice <= 1000) return "500-1000";
//   if (highestPrice <= 1500) return "1000-1500";
//   if (highestPrice <= 2000) return "1500-2000";
//   return "2000+";
// };

// const getHighestCharge = (pricing: {
//   standardFees: {
//     individual?: {
//       amount: string;
//       currency: string;
//       location?: "India" | "International";
//     };
//     couples?: {
//       amount: string;
//       currency: string;
//       location?: "India" | "International";
//     };
//   };
//   slidingScale?: {
//     range?: {
//       min: string;
//       max: string;
//     };
//     fixedAmount?: string;
//     availableFor?: string[];
//     slots?: number;
//   };
// }): string => {
//   const individualAmount = pricing.standardFees.individual?.amount
//     ? parseInt(pricing.standardFees.individual.amount)
//     : 0;
//   const couplesAmount = pricing.standardFees.couples?.amount
//     ? parseInt(pricing.standardFees.couples.amount)
//     : 0;

//   return Math.max(individualAmount, couplesAmount).toString();
// };

// Therapist Data Store

export const THERAPISTS: Record<string, Therapist> = {
  "therapist-1": {
    id: "therapist-1",
    displayId: "Therapist 1",
    name: "Aanya Wadhwani",
    pronouns: "they/them",
    qualifications: [
      {
        degree:
          "MA in Applied Psychology (Specialized in Clinical and Counselling Practice)",
        institution: "",
      },
    ],
    avatar: "/images/team/anya.jpeg",
    specialization: [
      "Trauma",
      "Grief",
      "Romantic and Peer Relationships",
      "Familial dynamics",
      "Sexuality and Gender related concerns",
    ],
    bio: "With over 3 years of experience as a therapist, I use IFS as my guiding modality. I work with clients from the youth population, specifically women and queer-trans folx, to meet themselves in the way they always deserved to - kindly, compassionately, gently, and curiously. The niche that we create, is aimed at clients healing their long-worn wounds of trauma, accepting themselves as the `good enough` persons that they are, and finding grace in their everyday existence!",
    experience: 4,
    experienceRange: "4+ years",
    languages: ["English"],
    availability: [
      {
        days: "Mon-Sun (except Sunday & Tuesday)",
        hours: "10am-7pm",
      },
    ],
    contact: {
      email: "aanyaw8@gmail.com",
      phone: "+91 85910 49845",
      location: "Greh Pravesh Therapy and Healing centre, Patel Nagar, Delhi",
      linkedin: "https://www.linkedin.com/in/wadhwaniaanya/",
    },
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1800",
            currency: "Rs",
          },
          couples: {
            amount: "2650",
            currency: "Rs",
          },
          family: {
            amount: "2950",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        availableFor: ["students", "interns", "those in-between jobs"],
      },
      priceRange: "1500-2000",
      highestCharge: "2400",
    },
    serviceIds: ["couples-therapy", "family-therapy"],
    concerns: [
      "Trauma",
      "Grief",
      "Romantic and Peer Relationships",
      "Familial dynamics",
      "Sexuality and Gender related concerns",
    ],
    directConcernsTags: [
      "Trauma",
      "Grief & Loss",
      "Romantic Relationships",
      "Friendships & Peer Concerns",
      "Familial Relationships",
      "Gender Identity - related concerns",
      "Sexuality - related concerns",
    ],
    blogs: [
      "bi-invisibility",
      "mindfulness-blog",
      "trauma-memories-differ-from-other-memories",
    ],
  },

  "therapist-2": {
    id: "therapist-2",
    displayId: "Therapist 2",
    name: "Himanshi Thadani",
    pronouns: "She/her",
    qualifications: [
      {
        degree: "M.A. Clinical Psychology ",
        institution: "",
      },
    ],
    avatar: "/images/team/himanshi.jpeg",
    specialization: [
      "Anxiety and depression symptoms",
      "Relationship issues",
      "Family Conflicts",
      "Career related concerns",
      "Individual concerns",
      "Domestic issues",
      "Grief counselling",
      "Queer friendly assistance.",
    ],
    bio: "I work with the idea that therapy should be unique to each person with their set of experiences. I practice an eclectic approach with client centric assistance and unconditional support being at the heart of it. One can expect the provision of a safe, open space to explore and experiment, while working together in the therapeutic space with me.",
    experience: 5,
    experienceRange: "4+ years",
    languages: ["English", "Hindi"],
    availability: [
      {
        days: "Mon-Sat",
        hours: "10am-10pm",
      },
    ],
    contact: {
      email: "himanshithadani@gmail.com",
      phone: "+91 88607 70036",
      linkedin:
        "https://www.linkedin.com/in/himanshi-t-22356520a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "2000",
            currency: "Rs",
            location: "India",
          },
          couples: {
            amount: "3000",
            currency: "Rs",
            location: "India",
          },
        },
      ],
      slidingScale: {
        availableFor: ["students", "non-working professionals"],
      },
      priceRange: "2000+",
      highestCharge: "3000",
    },
    serviceIds: ["couples-therapy"],
    concerns: [
      "Anxiety and depression symptoms",
      "Relationship issues",
      "Family Conflicts",
      "Career related concerns",
      "Individual concerns",
      "Domestic issues",
      "Grief counselling",
      "Queer friendly assistance.",
    ],
    directConcernsTags: [
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Romantic Relationships", // From "Relationship issues" - can be broad
      "Familial Relationships", // From "Relationship issues" and "Family Conflicts"
      "Friendships & Peer Concerns", // From "Relationship issues" - can be broad
      "Career & Academic Stress",
      "Self-Esteem & Confidence", // From "Individual concerns" - common interpretation
      "Identity Exploration", // From "Individual concerns" - common interpretation
      "Grief & Loss",
      "Sexuality - related concerns", // From "Queer friendly assistance"
      "Gender Identity - related concerns", // From "Queer friendly assistance"
    ],
    reviews: [
      {
        client: "",
        review:
          "Himanshi Thadani is a compassionate and insightful therapist. She creates a safe, non-judgmental space and listens attentively. Her approach is thoughtful and adaptable, making it easy to open up. She’s also flexible with scheduling, which is great for busy professionals. Highly recommend her for anyone seeking a supportive therapist.",
      },
      {
        client: "",
        review:
          "I started therapy with Himanshi last year while houng through big changes. Himanshi has helped me cope a lot and i always look forward to our sessions!",
      },
      {
        client: "",
        review:
          "Himanshi ma’am made me feel very heard and comforted. She is extremely patient and kind and helped me take small steps one at a time. Would definitely recommend!",
      },
      {
        client: "",
        review:
          "I’ve been taking therapy sessions with Himanshi for the past six months, and it has been an incredibly positive and transformative experience. Her approach is tailored to each client, making the process feel deeply personal and effective. She understands me well, creating a safe and non-judgmental space where I can truly open up. I highly recommend Himanshi and her entire team to anyone considering therapy. Their professionalism, empathy, and expertise made a real difference in my mental well being.",
      },
    ],
  },

  "therapist-3": {
    id: "therapist-3",
    displayId: "Therapist 3",
    name: "Akash Agarwal",
    pronouns: "he/him",
    qualifications: [
      {
        degree: "M.Sc. Psychology (Clinical)",
        institution: "",
      },
    ],
    avatar: "/images/team/akash.jpeg",
    specialization: ["Narrative Therapy"],
    bio: "I work from a family and systems point-of-view. Which translates to focusing on how experiences in family and society shape/d you and your interactions with yourself and others at present. In my practice we explore and build your resources which shape how you experience the pleasant and difficult events of your life. I believe we become what we learnt and we live as we learn.",
    experience: 2,
    experienceRange: "1-2 years",
    languages: ["English", "Hindi"],
    availability: [
      {
        days: "Tue-Sat",
        hours: "9am-4pm",
      },
    ],
    contact: {
      email: "akashpsyche@gmail.com",
      phone: "+91 99531 13069",
      linkedin: "https://www.linkedin.com/in/akash-agarwal-0a77531a3/",
    },
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1500",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        fixedAmount: "1200",
        slots: 2,
      },
      priceRange: "1000-1500",
      highestCharge: "1500",
    },
    serviceIds: ["individual-therapy"],
    concerns: ["Family Issues", "Personal Growth"],
    directConcernsTags: [
      "Familial Relationships",
      "Self-Esteem & Confidence", // "Personal Growth" often links to this
      "Identity Exploration", // "Personal Growth" also links to this
    ],
  },

  "therapist-4": {
    id: "therapist-4",
    displayId: "Therapist 4",
    name: "Ambika Agnihotri",
    pronouns: "she/her",
    qualifications: [
      {
        degree: "M.A. in Psychology",
        institution: "",
      },
    ],
    avatar: "/images/team/ambika.jpg",
    specialization: [
      "Trauma",
      "Relationships",
      "Anxious and Depressive Mood",
      "Adjustment",
      "Physical/somatic Pain",
      "Growth and Healing",
    ],
    bio: "I follow an eclectic, trauma-informed, and personalised approach to counselling and therapy. I believe that my process and space should adapt to you, rather than you having to fit into a narrow general process. I use a mix of cognitive, sub-cognitive, somatic and spiritually-augmented modalities and techniques. I work with individuals and groups diverse in age, identity, background and goals. I align with humanistic-existential, client-centred and eastern-indigenous school of thought. I believe every single one of us can benefit immensely by working on our mental health! ",
    experience: 3,
    experienceRange: "3-4 years",
    languages: ["English", "Hindi"],
    availability: [
      {
        days: "Mon-Sun",
        hours: "10am-10pm",
      },
    ],
    contact: {
      email: "ambikaagnihotri1@gmail.com",
      phone: "+91 98140 04089",
      linkedin:
        "https://www.linkedin.com/in/ambika-agnihotri-703081231?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1500",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "1200",
          max: "1500",
        },
      },
      priceRange: "1000-1500",
      highestCharge: "1500",
    },
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Relationships",
      "Anxiety",
      "Depression",
      "Physical Pain",
      "Personal Growth",
    ],
    directConcernsTags: [
      "Trauma",
      "Romantic Relationships", // From "Relationships"
      "Familial Relationships", // From "Relationships"
      "Friendships & Peer Concerns", // From "Relationships"
      "Anxiety & Overthinking", // From "Anxiety" and "Anxious and Depressive Mood"
      "Depression & Low Mood", // From "Depression" and "Anxious and Depressive Mood"
      "Sleep & Somatic Complaints", // From "Physical Pain" / "Physical/somatic Pain"
      "Life Transitions", // From "Adjustment"
      "Self-Esteem & Confidence", // From "Personal Growth" / "Growth and Healing"
      "Identity Exploration", // From "Personal Growth" / "Growth and Healing"
    ],
  },

  "therapist-5": {
    id: "therapist-5",
    displayId: "Therapist 5",
    name: "Anindita Audhkhasi",
    pronouns: "she/her",
    qualifications: [
      {
        degree: "M.Sc. in Clinical Psychology",
        institution: "Christ University",
      },
    ],
    avatar: "/images/team/anindita.jpeg",
    specialization: [
      "Trauma",
      "Interpersonal relationships",
      "Grief and loss",
      "Academic productivity stress",
      "Self exploration",
      "Gender and Sexuality",
      "Eating and Mood difficulty",
    ],
    bio: "In my practice, I cater to people between the ages of 18-40 years. I work with common concerns of adulthood, such as career development and uncertainty, body image issues, gender and sexuality, navigating relationships (romantic, friendships, family), productivity-related stress, loss and grief, work-life balance and personal growth. My therapeutic lens is trauma-informed, queer and trans affirmative and strength-based.",
    experience: 1,
    experienceRange: "1-2 years",
    languages: ["English", "Hindi"],
    availability: [
      {
        days: "Mon-Sat",
        hours: "8 pm - 9 pm",
      },
      {
        days: "Sunday",
        hours: "9 am - 5 pm",
      },
    ],
    contact: {
      email: "aninditaaudhkhasi.therapy@gmail.com",
      phone: "+91 88007 65555",
      location: "Greh Pravesh Therapy and Healing centre, Patel Nagar, Delhi",
      linkedin: "https://www.linkedin.com/in/anindita-audhkhasi-995659190",
    },
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "600",
          max: "800",
        },
      },
      priceRange: "500-1000",
      highestCharge: "1000",
    },
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Interpersonal relationships",
      "Grief and loss",
      "Academic productivity stress",
      "Self exploration",
      "Gender and Sexuality",
      "Eating and Mood difficulty",
    ],
    directConcernsTags: [
      "Trauma",
      "Romantic Relationships", // From "Interpersonal relationships"
      "Familial Relationships", // From "Interpersonal relationships"
      "Friendships & Peer Concerns", // From "Interpersonal relationships"
      "Grief & Loss",
      "Career & Academic Stress", // From "Academic productivity stress"
      "Identity Exploration", // From "Self exploration"
      "Gender Identity - related concerns", // From "Gender and Sexuality"
      "Sexuality - related concerns", // From "Gender and Sexuality"
      "Body Image Concerns", // "Eating and Mood difficulty" can relate to this
      "Depression & Low Mood", // "Eating and Mood difficulty" can relate to this
      "Extreme Moods",
    ],
  },

  "therapist-6": {
    id: "therapist-6",
    displayId: "Therapist 6",
    name: "Deshna Gundecha",
    pronouns: "she/her",
    qualifications: [
      {
        degree: "MA in Counselling Psychology",
        institution: "",
      },
      {
        degree: "MSc Organisational Psychology",
        institution: "",
      },
    ],
    avatar: "/images/team/deshna.jpg",
    specialization: [
      "Trauma",
      "Grief & Loss",
      "Romantic Relationships",
      "Self-Esteem & Confidence",
      "Body Image Concerns",
    ],
    bio: "Hi, I’m Deshna, a trauma-informed and inclusive psychologist who’s here to hold space for you, just as you are. My work is relational and insight-oriented, which means we’ll look at how your past experiences, relationships, and environments may have shaped how you relate to yourself and others today. I also draw from mindfulness, somatic practices, psychodynamic ideas, and humanistic–existential values .Therapy with me is about gently reconnecting with the parts of you that may have been silenced, shamed, or forgotten, and finding your way back to your voice, agency, and truth.",
    experience: 3,
    experienceRange: "3-4 years",
    languages: ["English", "Hindi"],
    availability: [
      {
        days: "Mon-Fri",
        hours: "11:00 am - 7:30 pm",
      },
    ],
    contact: {
      email: "deshnagundecha.work@gmail.com",
      phone: "+91 7057052226",
      location: "Pune",
      linkedin: "http://www.linkedin.com/in/deshnagundecha",
    },
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "700",
          max: "900",
        },
        availableFor: ["Students", "Unemployed Individuals"],
      },
      priceRange: "1000-1500",
      highestCharge: "1200",
    },
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Grief & Loss",
      "Romantic Relationships",
      "Self-Esteem & Confidence",
      "Body Image Concerns",
    ],
    directConcernsTags: [
      "Trauma",
      "Romantic Relationships", // From "Interpersonal relationships"
      "Familial Relationships", // From "Interpersonal relationships"
      "Friendships & Peer Concerns", // From "Interpersonal relationships"
      "Grief & Loss",
      "Career & Academic Stress", // From "Academic productivity stress"
      "Identity Exploration", // From "Self exploration"
      "Gender Identity - related concerns", // From "Gender and Sexuality"
      "Sexuality - related concerns", // From "Gender and Sexuality"
      "Body Image Concerns", // "Eating and Mood difficulty" can relate to this
      "Depression & Low Mood", // "Eating and Mood difficulty" can relate to this
      "Extreme Moods",
    ],
  },

  // "therapist-6": {
  //   id: "therapist-6",
  //   displayId: "Therapist 6",
  //   name: "Neha Sikerwar",
  //   pronouns: "she/her",
  //   qualifications: [
  //     {
  //       degree: "M.Sc. in Counselling Psychology",
  //       institution: "",
  //     },
  //     {
  //       degree: "Certified Trauma-informed Somatic practitioner",
  //       institution: "",
  //     },
  //   ],
  //   avatar: "/images/team/neha-sikerwar.png",
  //   specialization: [
  //     "Processing Trauma",
  //     "Attachment Difficulties",
  //     "Identity Exploration",
  //     "Interpersonal/relational Challenges",
  //     "Grief",
  //     "Neurodivergence (Autism or ADHD) experiences",
  //     "Emotional Regulation",
  //     "Queer Affirming",
  //   ],
  //   bio: "I am a Neurodiergent (AuDHD) and Queer affirmative counselling psychologist and trauma-informed somatic practitioner. My journey with trauma and lived experiences of autism has deepened my ability to empathize, understand and connect with my clients. I try to create a safe space for my clients to support healing, self-discovery and growth. My approach is rooted in collaboration and compassion, creating a safe, genuine, and supportive space where you can be comfortable exploring yourself with curiosity and expressing your emotions authentically. By integrating mindfulness techniques, somatic practices, attachment-focused work, and an intersectional perspective, I aim to help you feel more present, deepen your connections, and cultivate a stronger sense of agency over your life and well-being. My practice incorporates EFT and body-based approaches to support your healing journey.",
  //   experience: 1,
  //   experienceRange: "1-2 years",
  //   languages: ["English", "Hindi"],
  //   availability: [
  //     {
  //       days: "Mon-Fri",
  //       hours: "3pm-7pm",
  //     },
  //   ],
  //   contact: {
  //     email: "thattraumatherapist@gmail.com",
  //     phone: "+91 7533849394",
  //     linkedin: "https://www.linkedin.com/in/neha-sikerwar-785514113?",
  //     instagram: "https://www.instagram.com/that_trauma_therapist",
  //   },
  //   pricing: {
  //     standardFees: [
  //       {
  //         individual: {
  //           amount: "1000",
  //           currency: "Rs",
  //         },
  //       },
  //     ],
  //     slidingScale: {
  //       range: {
  //         min: "1000",
  //         max: "1500",
  //       },
  //     },
  //     priceRange: "1000-1500",
  //     highestCharge: "1500",
  //   },
  //   serviceIds: ["individual-therapy"],

  //   concerns: [
  //     "Processing Trauma",
  //     "Attachment Difficulties",
  //     "Identity Exploration",
  //     "Interpersonal/relational Challenges",
  //     "Grief",
  //     "Neurodivergence (Autism or ADHD) experiences",
  //     "Emotional Regulation",
  //     "Queer Affirming",
  //   ],
  //   directConcernsTags: [
  //     "Trauma",
  //     "Romantic Relationships", // From "Attachment Difficulties" & "Interpersonal/relational Challenges"
  //     "Familial Relationships", // From "Attachment Difficulties" & "Interpersonal/relational Challenges"
  //     "Friendships & Peer Concerns", // From "Interpersonal/relational Challenges"
  //     "Identity Exploration",
  //     "Grief & Loss",
  //     "Neurodivergence",
  //     "Extreme Moods", // "Emotional Regulation" often implies difficulty managing moods
  //     "Stress & Burnout", // "Emotional Regulation" can be linked to stress
  //     "Gender Identity - related concerns", // From "Queer Affirming"
  //     "Sexuality - related concerns",
  //   ],
  //   reviews: [
  //     {
  //       client: "Snm",
  //       review:
  //         "Neha Mam, you are a good Counsellor. Even though our counselling sessions were less, we really made good use of time. You are a good listener, which is what a counsellor should have. You made me understand and feel my emotions, which I have been trying to ignore for a very long time. One of my specific emotions is guilt, which I could not understand, but you made me realise how important it is to let it go and have peace with myself. I would like to thank you from the bottom of my heart. I will always remember you as a good Counselor. Thank you once again.",
  //     },
  //     {
  //       client: "Bhv",
  //       review:
  //         "I feel very good about myself after talking to you, and I feel light. Because of you, I was able to deal with my anger. I am able to emotionally regulate myself now. I have seen myself growing with you. I face my problems now. You always understand me, and at the same time, you make me realise my own mistakes. I have tried many counsellors before, but you are the best.",
  //     },
  //     {
  //       client: "Ki",
  //       review:
  //         "I have learned a lot from your counselling. You have helped me with things that I had forgotten. I like the way you make me realise. I had forgotten how to be happy, but you made me smile again. Whenever I felt stuck, you have helped me a lot. I want to continue my counselling with you. You heard me and understood me; for that, thank you so much.",
  //     },
  //     {
  //       client: "Nik",
  //       review:
  //         "Neha Mam‘s counselling is excellent. She is a good listener and she makes you focus on your emotions and makes you connect with your inner self. She is easy to talk to and connect with on a personal level. I like the way her counselling was proceeding from start to end. There was one of the incidents where I was so emotionally drained and could not connect with my inner self. That’s when she made me do a spiritual exercise, and I genuinely felt the connection. Thank you, Neha mam, for conducting my counselling. It was a wonderful experience. I liked the way you carried the conversation between you and me and the way the counselling went on.",
  //     },
  //   ],
  // },

  "therapist-7": {
    id: "therapist-7",
    displayId: "Therapist 7",
    name: "Anushka Chawla",
    pronouns: "she/her",
    qualifications: [
      {
        degree: "MA in Psychology",
        institution: "",
      },
      {
        degree: "Certified Suicide Prevention First Aider",
        institution: "",
      },
      {
        degree: "Certified Trauma-informed Practitioner",
        institution: "",
      },
      {
        degree: "Trained in Grief Therapy",
        institution: "",
      },
    ],
    avatar: "/images/team/anushka-chawla.JPG",
    experienceRange: "1-2 years",
    languages: ["English", "Hindi"],
    experience: 1,
    availability: [
      {
        days: "Monday-Fridday",
        hours: "12:00 PM - 8:30 PM",
      },
      {
        days: "Saturday",
        hours: "12:00 PM - 6:00 PM"
      }
    ],
    bio: `I support young adults (18–35) in navigating life’s challenges with self-compassion. My eclectic approach blends CBT, DBT, REBT, Humanistic and Trauma-Informed Care. Therapy with me is warm, collaborative and tailored to your unique needs, whether you seek tools for anxiety, space for grief, or support with relationships and self-worth. You’re not broken. Together, we’ll understand your patterns and build strategies for a more fulfilling life.`,
    specialization: [
      "Grief & Loss",
      "Romantic Relationships",
      "Friendships & Peer Concerns",
      "Stress & Burnout",
      "Self-Esteem & Confidence",
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000-1200",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "400",
          max: "600",
        },
        availableFor: ["Students and Unemployed individuals"]
      },
      priceRange: "1000-1500",
      highestCharge: "1200",
    },
    contact: {
      email: "innerbloomcounseling@yahoo.com",
      phone: "+91 8336995914",
      linkedin: "https://www.linkedin.com/in/anushka-chawla-1056692b6",
      instagram:
        "https://www.instagram.com/innerbloomcounseling.in/?igsh=YTMycmMwdm1scjhm&utm_source=qr#",
    },
    serviceIds: ["individual-therapy"],
    concerns: [
      "Grief & Loss",
      "Romantic Relationships",
      "Friendships & Peer Concerns",
      "Stress & Burnout",
      "Self-Esteem & Confidence",
    ],
    directConcernsTags: [
      "Grief & Loss",
      "Romantic Relationships",
      "Friendships & Peer Concerns",
      "Stress & Burnout",
      "Self-Esteem & Confidence",
    ],
    probono: true,

    reviews: [
      {
        client: "Kashish",
        review:
          "Working with Anushka has been very beneficial for me. She has always been a strong support for me. Even though our sessions were limited , each one of them helped me understand myself better. She always listened to me without any judgement and provided a safe space. Working with her has been an amazing experience, and I will always be excited to seek her guidance im the future.",
      },
      {
        client: "Krish",
        review:
          "Working through my issues in therapy has been a truly transformative experience. My therapist, Anushka is not only an incredible therapist but also a wonderful person. Throughout our journey together, she has been consistently supportive and kind. She knows exactly how to guide me through difficult times with empathy and respect. The progress I’ve made under her care has been beyond what I ever imagined possible. Her ability to adapt and apply different approaches with both flexibility and consistency has been incredibly valuable.",
      },
      {
        client: "Shashwat Sharma",
        review:
          "Anushka is a very understanding, down-to-earth person, who not only helps you let your guard down and makes you feel in a secure, comfortable environment but also addresses your concerns in an easy-to-comprehend manner. Would recommend her 11 times out of 10!",
      },
    ],
  },
  "therapist-8": {
    id: "therapist-8",
    displayId: "Therapist 8",
    name: "Divya Khattar",
    pronouns: "she/her",
    avatar: "/images/team/divya-khattar.jpeg",
    qualifications: [
      {
        degree: "MSc. in Counselling Psychology",
        institution: "",
      },
      {
        degree: "Certified in Trauma Tapping Technique ",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday to Friday",
        hours: "10 AM - 9 PM",
      },
      {
        days: "Saturday & Sunday",
        hours: "10 AM - 4 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "3000-6000",
            currency: "Rs",
            location: "India",
          },
        },
        {
          individual: {
            location: "International",
            amount: "Depends on location of residence",
            currency: "",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "2000",
          max: "3000",
        },
        availableFor: [
          "2 slots for students and/or unemployed individuals subject to availability",
        ],
      },
      priceRange: "1500-2000",
      highestCharge: "2000",
    },
    bio: "I’m a therapist and a passionate mental health advocate, warmly welcoming anyone looking to navigate life’s challenges or simply grow into their better versions. My approach is eclectic, trauma-informed, person-centered, and relational, creating a safe space for self-exploration and healing. I have experience working with adults in the age range of 18-45 years on concerns like (but not limited to) self & identity, interpersonal relationships (romantic, friendships, family), trauma, anxiety, stress, work-life balance, adult ADHD, behavioral addictions, and abuse. I particularly enjoy working with highly sensitive people (HSPs) and empaths, helping them understand and embrace their depth. Therapy with me is collaborative—you have full agency. My goal is to support you with insight, tools, and a space to feel truly heard and held!",
    experience: 1.5,
    experienceRange: "Less than 1 year",
    specialization: [
      "Relationships",
      "Self & Identity",
      "Trauma",
      "Anxiety",
      "Attachment History & Childhood",
      "Narcissistic Abuse",
    ],
    contact: {
      email: "diywithdivya07@gmail.com",
      phone: "+91 9971129666",
      linkedin: "https://www.linkedin.com/in/-divyakhattar-",
      instagram:
        "https://www.instagram.com/_diywithdivya_?igsh=MW4ycnhzZjBtdGgzNQ%3D%3D&utm_source=qr",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Relationships",
      "Self & Identity",
      "Trauma",
      "Anxiety",
      "Attachment History & Childhood",
      "Narcissistic Abuse",
    ],
    directConcernsTags: [
      "Romantic Relationships", // From "Relationships", "Attachment History"
      "Familial Relationships", // From "Relationships", "Attachment History", "Narcissistic Abuse"
      "Friendships & Peer Concerns", // From "Relationships"
      "Identity Exploration", // From "Self & Identity"
      "Self-Esteem & Confidence", // From "Self & Identity"
      "Trauma", // From "Trauma", "Attachment History & Childhood", "Narcissistic Abuse"
      "Anxiety & Overthinking",
    ],
    reviews: [
      {
        client: "Suyash Srivastava",
        review:
          "Therapy isn’t just for when things go wrong sometimes, it’s just nice to have someone who listens, really listens, and gives you honest, non-judgy takes on what’s going on in your head. Think of it like journaling… except your journal talks back, remembers everything, and occasionally calls you out (gently). Very naive way to describe it but that’s what therapy with Divya feels like. I’ve been seeing her for over a year now, and honestly, I can’t imagine doing therapy with anyone else. She’s warm, kind, and somehow remembers the tiniest details I’ve mentioned in passing. It’s wild how much she genuinely cares and shows up for her clients - even outside the sessions. She’s helped me untangle my thoughts, see things clearly, and just feel heard in a way that’s hard to explain. And the best part? There’s zero therapist-y fluff. Just real, grounded conversations with someone who actually gets it. I’ve been her client since her pro-bono days, and I’ll still be here when she becomes the most sought-after therapist in India (she already is in my book). If you’re reading this and thinking about starting therapy. Divya’s the one. No second thoughts.”",
      },
      {
        client: "Devansh Kamlani",
        review: `Have been meeting, Divya for session for last few months and have seen a lot of difference in myself and have been able to see changes in myself.

I would recommend everyone to atleast visit once.`,
      },
      {
        client: "Ardha Ramesh",
        review:
          "I had the privilege of working with Divya and I cannot recommend her enough. She possesses all the qualities that you would want in a therapist- she is patient, honest and supportive. Throughout our time together she guided me in my personal journey and equipped me with the tools I needed to navigate my struggles. She has the incredible ability to provide honest feedback in the gentlest way possible. But most importantly, she helped me identify and confront my struggles, drawing out the healthiest and most constructive plan of action for me. She genuinely cares about the progress of her clients and is committed to helping them thrive. I strongly recommend anyone who needs support to seek her services!",
      },
      {
        client: "Pratap Sunder",
        review:
          "My experience with Divya, being the first person I chose to guide me through therapy was truly very helpful. Her sessions made me feel comfortable and open about sharing the things that troubled me, even with someone I didn’t know. A simple conversation with her effortlessly turned into something deep and meaningful. Through her gentle reassurance, and genuine care, she guided me with empathy and kindness, helping me navigate feelings of being lost. Divya has a remarkable gift for making you feel seen, heard, and supported. She’s not just incredible at what she does; she’s an extraordinary soul who can connect with you on a level you would never expect!",
      },
      {
        client: "Reuben",
        review:
          "Working with Divya is very easy, She is very understanding and approachable, with excellent skills in managing anxiety and a wealth of knowledge.",
      },
      {
        client: "Fathima Zahra",
        review:
          "Ms.Divya bas been instrumental in helping me balance and regulate my emotions. This has significantly helped me in my professional and personal life. Her advice is practical, insightful and tailored to my needs, making each session something I genuinely look forward to. She also creates a safe and welcoming environment where I feel heard and understood.",
      },
      {
        client: "Yuvika Agrawal",
        review:
          "I am incredibly grateful for the support and care I received from my therapist Divya. She was truly amazing, offering compassion and understanding during times when I needed it most. Her professionalism and empathetic nature made a significant positive impact on my life. Highly recommend.",
      },
      {
        client: "Naureen",
        review:
          "I have had a great experience with Divya. She has helped me a lot in overcoming my fears, shame and my negative thinking. She has always been very kind, supportive and patient with me. She has changed my life by teaching me to be kinder and more loving to myself.",
      },
      {
        client: "Harsh Das",
        review:
          "Reflecting on my own experience with you, I can say with complete honesty you changed my life. You gave me the tools, strength, and compassion to face myself and rebuild the version of me I had only dreamed of becoming. Sessions with you weren’t just conversations; they were moments of self-discovery, lightbulb realizations, and deep healing. Your ability to listen, to guide, and to bring calm around the chaos is truly a gift to anyone lucky enough to cross paths with you :)",
      },
    ],
    blogs: ["hsp-journey"],
  },

  "therapist-9": {
    id: "therapist-9",
    displayId: "Therapist 9",
    name: "Nehal Lakhotia",
    pronouns: "she/her",
    avatar: "/images/team/nehal-lakhotia.jpg",
    qualifications: [
      {
        degree: "M.A. (Applied Psychology)",
        institution: "",
      },
      {
        degree: "Certified Trauma Informed practioner",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Friday",
        hours: "6 PM to 8 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "800",
          max: "1000",
        },
      },
      priceRange: "1000-1500",
      highestCharge: "1000",
    },
    bio: '"Know all the theories, master all the techniques, but as you touch a human soul be just another human soul." – Carl Jung. \n I take a person-centered approach, ensuring a safe, empathetic, and non-judgmental space for clients. I believe in the power of narratives and how our experiences shape us, helping clients process and reframe their stories. My approach integrates CBT, mindfulness, and acceptance and values-based work from ACT, tailored to each individual’s needs. At its core, therapy with me is about feeling heard, understood, and empowered to grow.',
    experience: 1,
    experienceRange: "1-2 years",
    specialization: [
      "Anxiety-Related Concerns",
      "Self-Esteem Issues",
      "Relationship & Interpersonal Issues",
      "Emotional Regulation & Stress Management",
      "General Distress & Coping Strategies",
      "Childhood Adversities",
    ],
    contact: {
      email: "therapywithnehal@gmail.com",
      phone: "+91 9772785067",
      linkedin: "http://www.linkedin.com/in/nehal-lakhotia-094b2b268",
      instagram: "",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Anxiety-Related Concerns",
      "Self-Esteem Issues",
      "Relationship & Interpersonal Issues",
      "Emotional Regulation & Stress Management",
      "General Distress & Coping Strategies",
      "Childhood Adversities",
    ],
    directConcernsTags: [
      "Anxiety & Overthinking",
      "Self-Esteem & Confidence",
      "Romantic Relationships", // From "Relationship & Interpersonal Issues"
      "Familial Relationships", // From "Relationship & Interpersonal Issues"
      "Friendships & Peer Concerns", // From "Relationship & Interpersonal Issues"
      "Stress & Burnout", // From "Emotional Regulation & Stress Management", "General Distress"
      "Extreme Moods", // From "Emotional Regulation"
      // "Coping Strategies" is not a direct category, but addressed by targeting the primary issues
      "Trauma",
    ],
  },

  "therapist-10": {
    id: "therapist-10",
    displayId: "Therapist 10",
    name: "Aditi Jain",
    pronouns: "she/her",
    avatar: "/images/team/aditi-jain.jpg",
    qualifications: [
      {
        degree: "MA Counseling Psychology",
        institution: "",
      },
      {
        degree: "Certificate Course in Trauma informed approach",
        institution: "",
      },
      {
        degree: "Certified Relationship Coach",
        institution: "",
      },
      {
        degree: "Diploma in Art therapy",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday-Friday",
        hours: "12:00 pm - 8:00 pm",
      },
      {
        days: "Weekends",
        hours: "4:00 pm - 8:00 pm",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000-1200",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "700",
          max: "900",
        },
        availableFor: ["Students"],
      },
      priceRange: "1000-1500",
      highestCharge: "1200",
    },
    bio: "My approach is trauma-informed, compassionate, and rooted in deep respect for each person's unique story. I work integratively, drawing from diverse therapeutic modalities to support healing, self-discovery, and emotional resilience. ",
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Trauma",
      "Grief",
      "Self-exploration & growth",
      "Emotional regulation",
      "Relationship Issues",
      "Anxiety and Stress Management",
    ],
    contact: {
      email: "therapywithaditij@gmail.com",
      phone: "+91 9811153869",
      linkedin:
        "https://www.linkedin.com/in/aditi-jain-4b33bb307?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      instagram:
        "https://www.instagram.com/makeoverurmind?igsh=ZmxlYmt4MXhoczlz",
      location: "House no. 600, Sector-9, Faridabad / Online",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Grief",
      "Self-exploration & growth",
      "Emotional regulation",
      "Relationship Issues",
      "Anxiety and Stress Management",
    ],
    directConcernsTags: [
      "Trauma",
      "Grief & Loss",
      "Identity Exploration", // From "Self-exploration & growth"
      "Self-Esteem & Confidence", // From "Self-exploration & growth"
      "Extreme Moods", // From "Emotional regulation"
      "Romantic Relationships", // From "Relationship Issues"
      "Familial Relationships", // From "Relationship Issues"
      "Friendships & Peer Concerns", // From "Relationship Issues"
      "Anxiety & Overthinking", // From "Anxiety and Stress Management"
      "Stress & Burnout",
    ],
    probono: true,
    reviews: [
      {
        client: "Anu",
        review: `My therapist was Aditi jain ma'am, she is amazing like seriously whenever I feel low and my insecurities everything she handles very well I really felt very good after just talking to her she listens to me , she made me feel happy and worthy and the most important my "I can't do it" to "I will get habit" journey. Thank you so much mam`,
      },
      {
        client: "Mahe",
        review:
          "Working with Aditi Jain was a very positive experience for me. She made me feel safe to express and process my emotions and traumas. She's really good at identifying one's strenghts. She also gives the sessions proper structure to make them productive. She also helped me see various perspectives of various situations which really helped me. Thankful to her.",
      },
      {
        client: "Bhuvane",
        review:
          "Having Aditi as my therapist is a blessing for me. She made me understand the true meaning of therapy. There was never a moment where I felt uncomfortable with her. And the bond I share with her is one of a lifetime. I hope more people come across therapists like Aditi!",
      },
      {
        client: "Sha",
        review:
          "This is my first ever therapy session and Aditi made me so comfortable, she listened to me without no judgements and hesitation and she felt like a safe space.",
      },
    ],
  },

  "therapist-11": {
    id: "therapist-11",
    displayId: "Therapist 11",
    name: "Naman Jain",
    pronouns: "he/him",
    avatar: "/images/team/naman-jain.jpg",
    qualifications: [
      {
        degree: "M.A. (Clinical Psychology)",
        institution: "",
      },
      {
        degree:
          "Certified and Trained DBT & Psychodynamic Therapy practitioner",
        institution: "",
      },
      {
        degree: "Certified Trauma Therapist",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Thursday, Saturday and Sunday, For rest, I will be available post 7 in the evenings.",
        hours: "",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1800",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "1500",
          max: "1800",
        },
      },
      priceRange: "1500-2000",
      highestCharge: "1800",
    },
    bio: "Therapy with me is a space where you don’t have to have it all figured out. Maybe you’re feeling overwhelmed by emotions that seem too big to handle, or maybe you’ve noticed certain patterns in your relationships or thoughts that you can’t seem to break. It could be that you’re carrying feelings—sadness, anxiety, frustration—that don’t always make sense, and you want to understand why. Whatever brings you here, my role is to help you make sense of it, at a pace that feels right for you.  I work with a blend of practical tools and deeper insight because I know that some days, you just need help making it through. That’s where DBT (Dialectical Behavior Therapy) comes in—helping you stay grounded in the present, regulate overwhelming emotions, and develop coping skills for the challenges you face. But I also know that just managing symptoms isn’t enough if we don’t understand what’s beneath them. That’s why I also bring in Psychodynamic lens, which allows us to explore the deeper layers of your emotions and experiences—understanding where they come from and how they shape your life today. Therapy with me isn’t about 'fixing' you because you aren’t broken. Instead, it’s about helping you feel more like yourself — less weighed down, more in control, and more connected to what truly matters to you. It’s about creating a space where you can be honest about what hurts, explore the patterns that keep you stuck, and build a life that feels more meaningful and balanced. Whether you’re looking for immediate support or long-term change, we’ll move at your pace, with curiosity, care, and without judgment. If this sounds like something you’d like to explore, I’m here. Let’s start the conversation.",
    experience: 4,
    experienceRange: "4+ years",
    specialization: [
      "Trauma",
      "Grief",
      "Addiction",
      "Self esteem related concerns",
      "Anxieties - Social, General and others",
      "Depression",
      "Complicated Familial relationships",
      "Self harm",
    ],
    contact: {
      email: "therapywithnaman@gmail.com",
      phone: "+91 9650141108",
      linkedin: "https://www.linkedin.com/in/namanjain057/",
      instagram: "https://www.instagram.com/sounds_of_seashell/",
      location: "Greh Pravesh Therapy and Healing centre, Patel Nagar, Delhi",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Grief",
      "Addiction",
      "Self esteem related concerns",
      "Anxieties - Social, General and others",
      "Depression",
      "Complicated Familial relationships",
      "Self harm",
    ],
    directConcernsTags: [
      "Trauma",
      "Grief & Loss",
      "Addiction & Coping Behaviors", // Covers "Addiction" and "Self harm" as a coping behavior
      "Self-Esteem & Confidence",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Familial Relationships",
    ],
    reviews: [
      {
        client: "Arpita Singh",
        review:
          "I’ve been seeing Naman Jain for the past three  years, and I’m genuinely thankful that I took that first step to reach out to him. In the beginning, I was quite anxious about opening up, but he created such a warm, non-judgmental space that it quickly put me at ease. His compassionate and thoughtful approach made me feel truly understood and supported. Over time, he has helped me untangle complex thoughts and emotions, offering insights that have been both eye-opening and empowering. His kindness, patience, and empathy have been a constant throughout this journey. I can wholeheartedly say that working with him has made a meaningful difference in my life. I highly recommend him to anyone looking for a therapist who truly cares and understands.",
      },
      {
        client: "Ruhi",
        review:
          "I'm visiting to Naman Jain for last 2 years and I m really glad for approaching him.He is understanding,empathetic and also kind .At first I was nervous but he made a really safe and non judgemental environment for me.His validation made me  feel truly seen and heard.He helped me to explore my thoughts and emotions and their insights were incredibly valuable. I highly recommend Naman Jain to anyone seeking therapy he is truly  great therapist.",
      },
      {
        client: "Aashna",
        review:
          "I've been attending sessions with Mr. Naman Jain for the past two years, and I must say it's been a truly transformative experience. Throughout my therapy journey, he has remained consistently understanding, professional, and open-minded. His active listening skills, thoughtful suggestions, and mind relaxing techniques have been incredibly helpful. I genuinely feel heard and supported in every session. Consulting him has truly been worth it!",
      },
      {
        client: "Atufa Akhtar",
        review:
          "I’ve been receiving guidance from Naman Sir for quite some time now, and it’s been a truly enriching experience. He’s not only a great therapist but also someone who encourages deep conversations—not just about my personal challenges, but about life as a whole. What sets him apart is that his approach goes beyond just listening. The tasks and activities he provides are incredibly helpful for introspection and gaining clarity. One of the aspects I appreciate the most is his take on mindfulness—it’s practical, grounded, and genuinely impactful. All in all, Naman Sir is a wonderful therapist to have by your side on your journey of growth and self-understanding.",
      },
      {
        client: "Aastha Shukla",
        review:
          "Naman Sir is honestly amazing. He listens really patiently and makes you feel super comfortable during the session. I felt like I could open up easily, and he gave me clear, helpful solutions to everything I was going through. After talking to him, I felt so much better and more at peace. Really grateful for the session!",
      },
      {
        client: "Hetal Jain",
        review: ` I Started therapy with Naman Jain in 2023 . From the very beginning, I felt a strong sense of trust in the process itself, and Naman Sir's approach only solidified that faith.
What truly stands out is his ability to create a safe and comfortable space. It's rare to find someone who can foster an environment where you feel genuinely able to express your emotions and uncertainties without judgment. This allowed me to truly "flow" and delve into the root of my issues.
Today, I can confidently say that I feel grounded and more self-assured. This transformation is largely thanks to Naman Jain's expertise and compassionate approach. He didn't just offer solutions; he empowered me to find my own strength and navigate life's challenges with greater resilience.`,
      },
    ],
    blogs: ["mindfulness-anchor"],
  },

  "therapist-12": {
    id: "therapist-12",
    displayId: "Therapist 12",
    name: "Ashly Abraham",
    pronouns: "she/her",
    avatar: "/images/team/ashly.jpg",
    qualifications: [
      {
        degree: "MSc (Clinical Psychology)",
        institution: "",
      },
      {
        degree: "Certified Couples, Marriage and Family therapist",
        institution: "",
      },
      {
        degree:
          " Currently pursuing certification in Trauma informed Psychosocial care",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Saturday",
        hours: "9:30 AM to 12:30 PM and 4:30 PM to 8:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1200",
            currency: "Rs",
          },
          couples: {
            amount: "2000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "600",
          max: "1000",
        },
      },
      priceRange: "1500-2000",
      highestCharge: "2000",
    },
    bio: "Hey! I’m a Psychologist who believes in your innate strength to heal and grow. I offer a safe, non-judgmental space to explore your thoughts and emotions at your pace. My integrative, client-centered approach focuses on your unique needs and the relationships that shape you. I also work with couples to strengthen connection, improve communication, and build lasting intimacy. Therapy is a journey of self-discovery, and I'm honored to walk it with you",
    experience: 2,
    experienceRange: "2-3 years",
    specialization: [
      "Romantic relationships",
      "Complicated familial relationships",
      "Emotional regulation and Anger Management",
      "Self-esteem related concerns ",
    ],
    contact: {
      email: "psychashly@gmail.com",
      phone: "+91 9315676263",
      linkedin: "https://www.linkedin.com/in/ashlya",
      instagram: "https://www.instagram.com/epiphanyhour7/",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy", "couples-therapy"],
    blogs: ["attachment-styles", "four-horsemen-relationships"],
    concerns: [
      "Romantic relationships",
      "Complicated familial relationships",
      "Emotional regulation and Anger Management",
      "Self-esteem related concerns ",
    ],
    directConcernsTags: [
      "Romantic Relationships",
      "Familial Relationships",
      "Extreme Moods", // From "Emotional regulation and Anger Management"
      "Stress & Burnout", // Anger management can also relate to stress responses
      "Self-Esteem & Confidence",
    ],
    reviews: [
      {
        client: "Vatsa Vyas",
        review:
          "Access to therapy has always felt like it should be a basic necessity, but as a student on a budget, it often seemed out of reach. Ashly made it possible for me to access the support I needed, and I couldn’t be more grateful. What I love most about my sessions with her is her genuine and honest approach. She isn’t afraid to call things out and point out what truly matters, helping me focus on solutions rather than dwelling on problems. Her solution-oriented approach has been incredibly empowering. Additionally, I’ve never met someone as accommodating and understanding as Ashly. She truly makes therapy feel accessible, supportive, and impactful. Access to therapy has always felt like it should be a basic necessity, but as a student on a budget, it often seemed out of reach. Ashly made it possible for me to access the support I needed, and I couldn’t be more grateful. What I love most about my sessions with her is her genuine and honest approach. She isn’t afraid to call things out and point out what truly matters, helping me focus on solutions rather than dwelling on problems. Her solution-oriented approach has been incredibly empowering.",
      },
      {
        client: "S. K",
        review:
          "It was so good... I don't have any experience of therapy or psychology etc so I was pretty nervous about everything but she made me feel very comfortable and I was able to open up a lot....a great listener and gave really great insights on my issues..... I had a great time. thanks a lot Ashly",
      },
      {
        client: "S. J",
        review:
          "I was very anxious but Ashly helped me undertstand what is going wrong and helped me learn ways to manage anxiety. I feel a lot more confident now.",
      },
    ],
  },

  "therapist-13": {
    id: "therapist-13",
    displayId: "Therapist 13",
    name: "Heym Mehta",
    pronouns: "she/they",
    avatar: "/images/team/heym.jpg",
    qualifications: [
      {
        degree: "MSc (Clinical Psychology)",
        institution: "",
      },
      {
        degree: "Queer Affirmative Therapist, Animal Assisted Therapist",
        institution: "",
      },
      {
        degree: "REBT practitioner",
        institution: "",
      },
      {
        degree: "Certified to work in Cancer and Palliative Care counselling.",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Friday",
        hours: "10:00 AM - 5:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1200",
            currency: "Rs",
          },
          couples: {
            amount: "2000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "800",
          max: "1500",
        },
      },
      priceRange: "1000-1500",
      highestCharge: "1500",
    },
    bio: "I’m a trauma-informed, neuro-queer-affirmative therapist who blends behavioural, narrative & somatic approaches keeping in mind a systemic and grief lens. I aim to hold space for your story with honesty, empathy, and a bit of humor. Whether you're navigating grief, family dynamics, platonic or romantic relationships or just trying to make sense of all the uncertainty and change—I’m here with grounded tools and care. I'm certified in palliative and cancer care, and also practice animal-assisted therapy (because animals make everything better).",
    experience: 2,
    experienceRange: "2-3 years",
    specialization: [
      "Grief & Loss",
      "Romantic Relationships",
      "Familial Relationships",
      "Sexuality - related concerns",
      "Neurodivergence",
    ],
    contact: {
      email: "heymmehta.work@gmail.com",
      phone: "+91 9819085180",
      location: "Khar and Vile Parle, Mumbai",
      linkedin: "https://www.linkedin.com/in/heym-m/",
      instagram: "https://www.instagram.com/epiphanyhour7/",
    },
    languages: ["English", "Hindi", "Gujrati"],
    serviceIds: ["individual-therapy"],
    blogs: ["bi-invisibility"],
    concerns: [
      "Grief & Loss",
      "Romantic Relationships",
      "Familial Relationships",
      "Sexuality - related concerns",
      "Neurodivergence",
    ],
    directConcernsTags: [
      "Romantic Relationships",
      "Familial Relationships",
      "Extreme Moods", // From "Emotional regulation and Anger Management"
      "Stress & Burnout", // Anger management can also relate to stress responses
      "Self-Esteem & Confidence",
    ],
  },

  // "therapist-13": {
  //   id: "therapist-13",
  //   displayId: "Therapist 13",
  //   name: "Vaishnavi Karnik ",
  //   pronouns: "she/they",
  //   avatar: "/images/team/vaishnavi.jpg",
  //   qualifications: [
  //     {
  //       degree: "MSc (Counselling Psychology)",
  //       institution: "",
  //     },
  //   ],
  //   availability: [
  //     {
  //       days: "Saturday",
  //       hours: "11 AM to 6 PM",
  //     },
  //     {
  //       days: "Tuesday-Friday",
  //       hours: "11 AM to 8 PM",
  //     },
  //   ],
  //   pricing: {
  //     standardFees: [
  //       {
  //         individual: {
  //           amount: "1500",
  //           currency: "Rs",
  //         },
  //       },
  //     ],
  //     slidingScale: {
  //       range: {
  //         min: "1000",
  //         max: "1200",
  //       },
  //     },
  //     priceRange: "1000-1500",
  //     highestCharge: "1500",
  //   },
  //   bio: "I use an ecclectic approach in my therapy practice. I lean towards Humanistic, CBT, DBT,  and Trauma-informed approaches. I tailor the therapy process according to the needs of each client, while taking tools and interventions from these approaches. My work is collaborative and feedback-driven. I strive to create a safe space for clients as I journey with them. I use a queer affirmative, caste affirmative and systemic lens in my work. ",
  //   experience: 2,
  //   experienceRange: "2-3 years",
  //   specialization: [
  //     "Trauma",
  //     "Grief",
  //     "Stress management",
  //     "Relationship concerns",
  //     "Gender and sexuality concerns",
  //     "Self-doubt issues ",
  //   ],
  //   contact: {
  //     email: "therapist.vaishnavi@gmail.com",
  //     phone: "+91 9108144296",
  //     linkedin: "https://www.linkedin.com/in/vaishnavikarnik/",
  //   },
  //   languages: ["English", "Hindi", "Kannada", "Tulu"],
  //   serviceIds: ["individual-therapy"],
  //   concerns: [
  //     "Trauma",
  //     "Grief",
  //     "Stress management",
  //     "Relationship concerns",
  //     "Gender and sexuality concerns",
  //     "Self-doubt issues ",
  //   ],
  // },

  "therapist-14": {
    id: "therapist-14",
    displayId: "Therapist 14",
    name: "Nandini Satija",
    pronouns: "she/her",
    avatar: "/images/team/nandini.png",
    qualifications: [
      {
        degree: "MA Psychology",
        institution: "",
      },
      {
        degree: " Trauma-informed, IFS-oriented therapist",
        institution: "",
      },
      {
        degree: "Trained Peer Supporter",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Saturday",
        hours: "12:30 PM to 2:30 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "500",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "0",
          max: "500",
        },
      },
      priceRange: "0-500",
      highestCharge: "500",
    },
    bio: "My goal is to provide a space where you feel truly seen, heard, &  valued—exactly as you are & I would be happy to walk alongside you on this journey. My approach is rooted in empathy, patience, and curiosity. I work from a trauma-informed lens, which means I understand how past experiences can shape the way we feel, think, & relate to the world today. I also use the principles of Internal Family Systems (IFS) to gently explore the different “parts” of you --- those that carry pain, self-doubt, or fear, as well as the parts that hold resilience, courage, & joy. Together, we’ll work toward harmony & self-connection.",
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Anxiety",
      "Anger Management",
      "Low self-worth and confidence",
      "Self-esteem related concerns",
      "Perfectionism",
      "Processing Trauma",
      "Complicated familial relationships & Anxiety ",
    ],
    contact: {
      email: "littlestepswithnandini@gmail.com",
      phone: "",
      linkedin: "https://linkedin.com/in/nandini-satija-9095ab205",
    },
    languages: ["English", "Hindi", "Punjabi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Self-esteem related concerns",
      "Perfectionism",
      "Trauma",
      "Complicated familial relationships & Anxiety ",
    ],
    directConcernsTags: [
      "Self-Esteem & Confidence", // From "Self-esteem related concerns", "Low self-worth and confidence"
      "Perfectionism",
      "Trauma", // From "Trauma", "Processing Trauma"
      "Familial Relationships", // From "Complicated familial relationships & Anxiety"
      "Anxiety & Overthinking", // From "Complicated familial relationships & Anxiety", "Anxiety"
      "Extreme Moods",
    ],
    probono: true,
  },

  "therapist-15": {
    id: "therapist-15",
    displayId: "Therapist 15",
    name: "Meenal Bachhawat",
    pronouns: "she/her",
    avatar: "/images/team/meenal-bachhawat.png",
    qualifications: [
      {
        degree: "MA Applied Psychology",
        institution: "",
      },
      {
        degree: "Certification in Trauma-Informed Care,",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday, Tuesday, Wednesday, Friday, and Saturday ",
        hours: "10:30 AM to 6 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1500",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "1000",
          max: "1500",
        },
      },
      priceRange: "1000-1500",
      highestCharge: "1500",
    },
    bio: "I’m a trauma-informed therapist who believes your body holds the wisdom it needs to heal. With 4 years of experience working in various environments, I have learnt to offer a compassionate space. Together, we’ll explore the mind-body connection, helping you understand yourself on a deeper level. My approach is all about kindness, curiosity, and creating a safe space where you can feel seen and supported.",
    experience: 4,
    experienceRange: "4+ years",
    specialization: [
      "Trauma",
      "Grief",
      "Self-growth",
      "Anxiety",
      "Relationships",
    ],
    contact: {
      email: "meenal.bachhawat@gmail.com",
      phone: "+91 9752217489",
      linkedin:
        "https://www.linkedin.com/in/meenal-bachhawat-she-her-92834012b/",
      instagram:
        "https://www.instagram.com/thetherapeuticpodcast_?igsh=eHdwYzZhM2xveDdq",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: ["Trauma", "Grief", "Self-growth", "Anxiety", "Relationships"],
    directConcernsTags: [
      "Trauma",
      "Grief & Loss",
      "Self-Esteem & Confidence", // From "Self-growth"
      "Identity Exploration", // From "Self-growth"
      "Anxiety & Overthinking",
      "Romantic Relationships",
      "Familial Relationships",
      "Friendships & Peer Concerns",
    ],
  },

  "therapist-16": {
    id: "therapist-16",
    displayId: "Therapist 16",
    name: "Soumya Gupta",
    pronouns: "she/her",
    avatar: "/images/team/soumya-gupta.jpeg",
    qualifications: [
      {
        degree: "MSc. Clinical Psychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Tuesday, Wednesday, Thursday",
        hours: "4:45 PM to 7:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "850",
            currency: "Rs",
            duration: "45 mins",
          },
        },
        {
          individual: {
            amount: "1000",
            currency: "Rs",
            duration: "60 mins",
          },
        },
      ],
      /*slidingScale: {
        range: {
          min: "500",
          max: "1000",
        },
      */
      priceRange: "500-1000",
      highestCharge: "700",
    },
    bio: "I typically work with adults aged 20 to 50 who are navigating emotional and psychological challenges. Whether you're facing a breakup, managing anxiety, healing from trauma, or adjusting to major life changes, I provide a safe, collaborative space for growth and healing. My approach to therapy is non-directive, collaborative, and non-pathologizing. I aim to make sessions relatable & comfortable, whether that means encouraging you to bring objects that make you feel safe to sessions or recommending books tailored to your interests. My methods include Cognitive Behavioral Therapy (CBT) and trauma-informed therapy, with a strong influence from Internal Family Systems (IFS) throughout my work.",
    experience: 1,
    experienceRange: "1-2 years",
    specialization: [
      "Trauma",
      "Interpersonal Relationships",
      "Depressive Symptoms",
      "Anxiety",
      "Overthinking",
    ],
    contact: {
      email: "therapywithsoumya@gmail.com",
      phone: "+91 9380012085",
      linkedin: "http://www.linkedin.com/in/soumya-gupta-psychology",
      location: "Hazareshwar Colony, Madhuban, Udaipur",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Interpersonal Relationships",
      "Depressive Symptoms",
      "Anxiety",
      "Overthinking",
    ],
    directConcernsTags: [
      "Trauma",
      "Romantic Relationships",
      "Familial Relationships",
      "Friendships & Peer Concerns",
      "Depression & Low Mood",
      "Anxiety & Overthinking",
    ],
    reviews: [
      {
        client: "Sathvika C.",
        review:
          "Having Soumya as my therapist was really helpful. She made me feel very comfortable and has really been beneficial on my mental health journey. Soumya helped me realise how important it was to prioritise myself and that changed a lot for me. I’ll always be grateful :)",
      },
      {
        client: "Neha Nair",
        review:
          "My experience working with Ms. Soumya Gupta has been great. Being my first experience at taking therapy, I was a bit skeptical about finding a therapist that would be a good fit for me, however I felt Ms. Soumya was able to understand me and my journey very well, and built a wonderful therapeutic relationship with me. I find her very professional, reflective, and understanding, with an in-depth theoretical understanding of the therapeutic techniques being used. She has helped me tremendously in my journey of self-discovery. A big thanks to her!",
      },
    ],
    blogs: ["trauma-memories-differ-from-other-memories"],
  },
  "therapist-17": {
    id: "therapist-17",
    displayId: "Therapist 17",
    name: "Madhulika Singhal",
    pronouns: "she/her",
    avatar: "/images/team/madhulika-singhal.jpg",
    qualifications: [
      {
        degree: "MA in Applied Psychology (Counselling and Clinical Practice)",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday-Friday",
        hours: "9 PM to 10 PM",
      },
      {
        days: "Saturday - Sunday",
        hours: "9:00 AM to 10:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "800",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "600",
          max: "800",
        },
      },
      priceRange: "500-1000",
      highestCharge: "800",
    },
    bio: "I take a Humanistic and Post-Modern approach to therapy, rooted in Trauma-Informed practice. I believe in the transformative potential of 'liminal' spaces - those profound moments where we often find ourselves 'in-between'. Whether you're questioning yourself, facing major changes, or feeling caught between who you've been and who you want to become, our work together will be about finding solid ground, nurturing self-compassion, and moving forward in a way that feels right for you. My work is deeply rooted in respecting diversity and foestering inclusivity, ensuring that therapy is a space where every experience is welcomed, understood, and met with genuine care.",
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Stress, worry, or overwhelming emotions",
      "Feelings of low confidence or self-worth",
      "Interpersonal concerns (friendships, relationship, family)",
      "Self-exploration & personal growth",
      "Questions regarding purpose & meaning in life",
    ],
    contact: {
      email: "madhulikas104a@gmail.com",
      phone: "+91 9810326841",
      linkedin: "https://www.linkedin.com/in/madhulika-singhal-9159701a0/",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Stress, worry, or overwhelming emotions",
      "Feelings of low confidence or self-worth",
      "Interpersonal concerns (friendships, relationship, family)",
      "Self-exploration & personal growth",
      "Questions regarding purpose & meaning in life",
    ],
    directConcernsTags: [
      "Stress & Burnout", // From "Stress, worry, or overwhelming emotions"
      "Anxiety & Overthinking", // From "worry, or overwhelming emotions"
      "Self-Esteem & Confidence", // From "Feelings of low confidence or self-worth"
      "Friendships & Peer Concerns", // From "Interpersonal concerns (friendships...)"
      "Romantic Relationships", // From "Interpersonal concerns (...relationship...)"
      "Familial Relationships", // From "Interpersonal concerns (...family)"
      "Identity Exploration",
    ],
  },

  "therapist-18": {
    id: "therapist-18",
    displayId: "Therapist 18",
    name: "Aanchal Chauhan",
    pronouns: "she/her",
    avatar: "/images/team/aanchal-chauhan.jpg",
    qualifications: [
      {
        degree: "Masters in Lifespan Counselling, PhD Scholar",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday-Friday",
        hours: "7 PM to 9 PM",
      },
      {
        days: "Sunday",
        hours: "10:00 AM to 9:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1500",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "650 (age < 21) and 800 (age > 21)",
          max: "800 (age < 21) and 1000 (age > 21)",
        },
      },
      priceRange: "1000-1500",
      highestCharge: "1500",
    },
    bio: "Hello! I’m Aanchal, and I wear multiple hats as a PhD scholar, supervisor, and therapist. With a strong academic foundation, I completed my Master’s in Lifespan Counseling from St. Xavier’s Mumbai and my Bachelor’s in Psychology from Lady Shri Ram College, Delhi. I’ve been practicing as a therapist for the past three years, specializing in trauma, relationship issues, self-esteem, body image issues, gender and sexuality, ADHD, grief and loss, overthinking, and anxiety. My approach to therapy is deeply relational, creative, and rooted in a constant curiosity to learn. As a therapist, I consider myself a feminist and, above all, a human. My practice is centered on connecting individuals with their inner worlds and the complexities that shape who they are. I draw on psychoanalytical, narrative, and Internal Family Systems (IFS) modalities to explore how our unconscious mind and life stories influence our core identity—our authentic self, which is free, creative, and courageous. At the same time, I acknowledge the survival self, which may show up as hyper-independence, anxiety, or perfectionism. If you decide to connect with me, all your parts will be welcomed. I reject the idea of an emotionless therapist, so you’ll often see me crying with you, laughing with you, and pacing the session at your pace. I believe in sitting beside you as a human, offering a space where you can feel fully safe, seen and heard. In my therapy space, everyone is welcomed with warmth and compassion, no matter their experiences or lived stories. I honor every part of you, even those parts that society or we, ourselves, often reject. My work is particularly focused on inner child and parts work, where I create a safe environment for clients to connect with parts of themselves that feel anxious, unworthy, or wounded. Through this connection, we rebuild relationships with these parts that are safe, empowering, and ultimately liberating. I firmly believe that there are no 'bad' parts of ourselves—only parts that have developed in response to our struggles in order to help us survive. Once we begin to connect with these parts, we can nurture them, heal them, and move closer to our higher self.",
    experience: 3,
    experienceRange: "3-4 years",
    specialization: [
      "Trauma",
      "Grief",
      "Gender and sexuality related concerns",
      "ADHD",
      "Interpersonal Concerns (Family, Romantic, Work )",
      "Overthinking and Anxiety ",
    ],
    contact: {
      email: "reauthoringnarratives@gmail.com",
      phone: "+91 9599331250",
      linkedin:
        "https://www.linkedin.com/in/aanchal-chauhan-622442189?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
      instagram:
        "https://www.instagram.com/reauthoring_narratives?igsh=Y2VhbnlsNjBibHNw&utm_source=qr",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Stress, worry, or overwhelming emotions",
      "Feelings of low confidence or self-worth",
      "Interpersonal concerns (friendships, relationship, family)",
      "Self-exploration & personal growth",
      "Questions regarding purpose & meaning in life",
    ],
    directConcernsTags: [
      "Trauma",
      "Grief & Loss",
      "Gender Identity - related concerns",
      "Sexuality - related concerns",
      "Neurodivergence", // From "ADHD"
      "Executive Functioning Difficulties", // Often comorbid with ADHD
      "Familial Relationships", // From "Interpersonal Concerns (Family...)"
      "Romantic Relationships", // From "Interpersonal Concerns (Romantic...)", "relationship issues"
      "Career & Academic Stress", // From "Interpersonal Concerns (...Work)"
      "Anxiety & Overthinking",
      "Self-Esteem & Confidence",
      "Body Image Concerns",
    ],
  },
  // "therapist-19": {
  //   id: "therapist-19",
  //   displayId: "Therapist 19",
  //   name: "Akshaya Murali",
  //   pronouns: "she/her",
  //   avatar: "/images/team/akshaya.jpg",
  //   qualifications: [
  //     {
  //       degree: "MSc Applied Psychology",
  //       institution: "",
  //     },
  //     {
  //       degree: "International certified career coach",
  //       institution: "",
  //     },
  //   ],
  //   availability: [
  //     {
  //       days: "Sat, Sun, Mon-Wed",
  //       hours: "6 PM to 8 PM",
  //     },
  //     {
  //       days: "Thrusday",
  //       hours: "9:00 AM to 6:00 PM",
  //     },
  //   ],
  //   pricing: {
  //     standardFees: [
  //       {
  //         individual: {
  //           amount: "1200",
  //           currency: "Rs",
  //         },
  //         couples: {
  //           amount: "1800",
  //           currency: "Rs",
  //         },
  //       },
  //     ],
  //     slidingScale: {
  //       range: {
  //         min: "800",
  //         max: "1000",
  //       },
  //     },
  //     priceRange: "1500-2000",
  //     highestCharge: "1800",
  //   },
  //   bio: " When you come to see me, you'll find that I approach therapy from a person-centered and humanistic perspective. What that means for you is that I’ll create a safe, supportive space where you can feel heard, valued, and understood without judgment. I believe in your ability to grow, heal, and find your own path forward, and I’m here to walk alongside you as you explore and navigate your challenges. I draw from a variety of therapeutic techniques to best support you, including Cognitive Behavioral Therapy (CBT), Rational Emotive Behavioral Therapy (REBT), Dialectical Behavioral Therapy (DBT), and Acceptance and Commitment Therapy (ACT). These approaches help us work together to identify and challenge negative thoughts, build emotional resilience, and make meaningful changes in your life. If you’re struggling with a gambling addiction or experiencing a crisis, I’m here to offer support, help you understand the underlying causes, and create healthier coping strategies. For couples counseling, I provide support in improving communication, resolving conflicts, and building healthier relationships. I work to help each partner express their needs, understand one another, and develop effective ways to navigate challenges together. Together, we’ll work toward lasting, meaningful change in a compassionate, collaborative environment.",
  //   experience: 2,
  //   experienceRange: "2-3 years",
  //   specialization: [
  //     "Self-esteem related concerns",
  //     "Romantic Relationships",
  //     "Friendships",
  //     "Work & Career related Concerns",
  //     "Anxiety",
  //   ],
  //   contact: {
  //     email: "akshaya27m@gmail.com",
  //     phone: "+91 9884668301",
  //   },
  //   languages: ["English", "Hindi", "Tamil"],
  //   serviceIds: ["individual-therapy", "couples-therapy"],
  //   concerns: [
  //     "Self-esteem related concerns",
  //     "Romantic Relationships",
  //     "Friendships",
  //     "Work & Career related Concerns",
  //     "Anxiety",
  //   ],
  //   directConcernsTags: [
  //     "Self-Esteem & Confidence",
  //     "Romantic Relationships",
  //     "Friendships & Peer Concerns", // From "Friendships"
  //     "Career & Academic Stress", // From "Work & Career related Concerns"
  //     "Anxiety & Overthinking",
  //   ],
  // },
  "therapist-20": {
    id: "therapist-20",
    displayId: "Therapist 20",
    name: "Shriya Shah",
    pronouns: "she/her",
    avatar: "/images/team/shriya-shah.jpg",
    qualifications: [
      {
        degree: "MA in Applied Psychology",
        institution: "",
      },
      {
        degree: "Certified Trauma Informed Practioner",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Weekends",
        hours: "10 AM to 5 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "500",
          max: "800",
        },
        availableFor: ["students and non working professional "],
      },
      priceRange: "500-1000",
      highestCharge: "1000",
    },
    bio: `I offer a steady, nonjudgmental space where you can show up just as you are. My approach is client-centered, collaborative, and trauma-informed. I’m also curious about how family, culture, relationships, and the systems around us interact and shape our sense of self, how we relate to others, and how we make meaning in our lives. 

I’m especially interested in how the mind and body hold experience, and how healing can begin by creating safety within. However you show up, you are welcome here 🌻
`,
    experience: 1,
    experienceRange: "1-2 years",
    specialization: [
      "Self esteem and self growth",
      "Grief and loss",
      "Body image issues",
      "Burnout",
      "Interpersonal concerns",
    ],
    contact: {
      email: "shriyashh11@gmail.com",
      phone: "+91 9004472227",
    },
    languages: ["English", "Hindi", "Gujrati"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Self esteem and self growth",
      "Grief and loss",
      "Body image issues",
      "Burnout",
      "Interpersonal concerns",
    ],
    directConcernsTags: [
      "Self-Esteem & Confidence", // From "Self esteem and self growth"
      "Identity Exploration", // From "self growth"
      "Grief & Loss",
      "Body Image Concerns",
      "Stress & Burnout", // From "Burnout"
      "Romantic Relationships", // From "Interpersonal concerns"
      "Familial Relationships", // From "Interpersonal concerns"
      "Friendships & Peer Concerns",
    ],
  },

  "therapist-21": {
    id: "therapist-21",
    displayId: "Therapist 21",
    name: "Mannya Chandy",
    pronouns: "she/her",
    avatar: "/images/team/mannya-chandy.jpg",
    qualifications: [
      {
        degree: "MSc in Counselling Psychology",
        institution: "",
      },
      {
        degree:
          "Externship in Emotionally Focused Couples Therapy, by The International Centre for Excellence in Emotionally Focused Therapy in Conjunction with TRI EFT Alliant",
        institution: "",
      },
      {
        degree:
          "60 Hour ADHD Bootcamp by The Coping Central, New Delhi, June 2024",
        institution: "",
      },
      {
        degree:
          "The Intensive Certificate Training in Rational Emotive Behaviour Therapy (REBT) by In Vivo-Centre for REBT, Mumbai, July 2024 ",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday",
        hours: "6 PM to 9:15 PM",
      },
      {
        days: "Tuesday, Thursday",
        hours: "8:30 AM to 11:45 AM, 4:30 PM to 6:30 PM",
      },
      {
        days: "Wednesday, Friday",
        hours: "10:30 AM to 1:30 PM, 6 PM to 9:15 PM",
      },
      {
        days: "Saturday",
        hours: "till 1:15 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1900",
            currency: "Rs",
            location: "India",
            duration: "45 mins",
          },
          couples: {
            amount: "3500",
            currency: "Rs",
            location: "India",
            duration: "75 mins",
          },
        },
        {
          individual: {
            amount: "2500",
            currency: "Rs",
            location: "International",
            duration: "45 mins",
          },
          couples: {
            amount: "4500",
            currency: "Rs",
            location: "International",
            duration: "75 mins",
          },
        },
      ],
      slidingScale: {
        slots: 0, // Assuming no sliding scale slots based on the data provided
      },
      priceRange: "1500-2000", // Chosen based on the majority of prices
      highestCharge: "5000",
    },
    bio: "I assist clients in exploring their individual pathways to forming connections, emphasizing emotional awareness and understanding. Through a schema and attachment-oriented perspective, I tailor my approach to meet each client's unique needs. As a counseling psychologist, I recognize the client as the expert in their own journey. In couples therapy, I employ an Emotionally Focused Couples Therapy (EFCT) approach, prioritizing the relationship dynamic between partners as central to our collaborative efforts.",
    experience: 4,
    experienceRange: "4+ years",
    specialization: [
      "Grief & Loss",
      "Romantic Relationships",
      "Familial Relationships",
      "Life Transitions",
    ],
    contact: {
      email: "mannyaechandy@gmail.com",
      phone: "+91 6366571522",
      linkedin: "https://www.linkedin.com/in/mannya-chandy-47bb6b87",
      instagram: "https://www.instagram.com/emotioncentredtherapist",
    },
    languages: ["English", "Hindi", "Malayalam"],
    serviceIds: ["individual-therapy", "couples-therapy"],
    concerns: [
      "Grief & Loss",
      "Romantic Relationships",
      "Familial Relationships",
      "Life Transitions",
    ],
    directConcernsTags: [
      "Grief & Loss",
      "Romantic Relationships",
      "Familial Relationships",
      "Life Transitions",
    ],
    reviews: [
      {
        client: "",
        review:
          "I have been with Mannya since 2020 , and she has been really supportive throughout my healing journey. It is always very comfortable with her and easy to communicate. She is very professional and helped me to look at the situation in a much more better way. I am still continuing my sessions with her and so much grateful about being able to find a professional like her.",
      },
      {
        client: "",
        review:
          "I have been a long time client of Mannya, she's been, in many ways, a true mirror for me to reflect on my patterns and experiences. She enabled me to see myself for who I am. I was feeling extremely hopeless when I started this journey with her and I left as someone with a lot of self-compassion, self-acceptance and self-confidence. She helped me with building all the necessary tools that helped me in my relationships as well. Would truly recommend her🌻.",
      },
      {
        client: "",
        review: "Professional, helpful and ease.",
      },
    ],
  },

  "therapist-22": {
    id: "therapist-22",
    displayId: "Therapist 22",
    name: "Sanya Gupta",
    pronouns: "she/her",
    avatar: "/images/team/sanya-gupta.jpg",
    qualifications: [
      {
        degree: "MA in Clinical Psychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday-Friday",
        hours: "10 AM to 6 PM",
      },
      {
        days: "Saturday",
        hours: "10 AM to 2 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "600",
          max: "800",
        },
      },
      priceRange: "500-1000", // Chosen based on the majority of prices
      highestCharge: "1000",
    },
    bio: "I take a client-centered approach to therapy, creating a safe and supportive environment where individuals can explore their thoughts, emotions, and experiences without fear of judgment. My practice is rooted in the existential-humanistic approach, emphasizing the importance of the therapeutic relationship as a foundation for healing and self-discovery. I recognize that every individual’s journey is unique, and I am committed to meeting my clients wherever they are in their personal growth. My goal is to create a space where clients feel truly heard, validated, and empowered to explore their challenges, strengths, and aspirations. I use a tailored, collaborative approach to help you gain clarity, build lasting resilience, and deepen your self-understanding, empowering you to move forward with confidence.",
    experience: 1,
    experienceRange: "1-2 years",
    specialization: [
      "Anxiety & stress management",
      "Self-growth & exploration",
      "Workplace Dynamics and Concerns",
      "Interpersonal Relationships",
      "familial",
    ],
    contact: {
      email: "sanyagupta.mh@gmail.com",
      phone: "+91 9220980382",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Anxiety & stress management",
      "Self-growth & exploration",
      "Workplace Dynamics and Concerns",
      "Interpersonal Relationships",
      "familial",
    ],
    directConcernsTags: [
      "Anxiety & Overthinking", // From "Anxiety & stress management"
      "Stress & Burnout", // From "Anxiety & stress management"
      "Self-Esteem & Confidence", // From "Self-growth & exploration"
      "Identity Exploration", // From "Self-growth & exploration"
      "Career & Academic Stress", // From "Workplace Dynamics and Concerns"
      "Romantic Relationships", // From "Interpersonal Relationships"
      "Friendships & Peer Concerns", // From "Interpersonal Relationships"
      "Familial Relationships",
    ],
  },

  "therapist-23": {
    id: "therapist-23",
    displayId: "Therapist 23",
    name: "Saumya Mishra",
    pronouns: "she/her",
    avatar: "/images/team/saumya-mishra.jpg",
    qualifications: [
      {
        degree: "MA in Counselling Psychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday-Sunday",
        hours: "11 AM to 7 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "500",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        slots: 0,
      },
      priceRange: "0-500", // Chosen based on the majority of prices
      highestCharge: "500",
    },
    bio: "If you choose to work with me, you can expect a safe, judgment-free space where you can show up exactly as you are. I know opening up takes time, so we’ll move at a pace that feels right for you, ensuring you feel heard, supported, and understood. My approach is gentle, trauma-informed, and personalized, there’s no one-size-fits-all in therapy. We might explore reflection, mindfulness, cognitive reframing, or creative techniques like art-based therapy, to help process emotions when words feel too heavy. If anxiety, stress, or self-doubt are weighing you down, we’ll work on grounding techniques, self-compassion, and small, manageable steps to help you regain a sense of control. More than anything, therapy with me is a collaborative journey. I won’t tell you what to do, but I’ll walk beside you, helping you make sense of your thoughts and emotions in a way that feels meaningful and empowering.",
    experience: 1,
    experienceRange: "1-2 years",
    specialization: [
      "Romantic relationships",
      "Self esteem related concerns",
      "Body image Issues",
      "Stress",
    ],
    contact: {
      email: "m.saumya022@gmail.com",
      phone: "+91 8766267202",
      linkedin: "https://in.linkedin.com/in/mishrasaumya",
      instagram: "https://www.instagram.com/untangleknots",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Anxiety & stress management",
      "Self-growth & exploration",
      "Workplace Dynamics and Concerns",
      "Interpersonal Relationships",
      "familial",
    ],
    directConcernsTags: [
      "Romantic Relationships",
      "Self-Esteem & Confidence", // From "Self esteem related concerns", "Self-doubt"
      "Body Image Concerns",
      "Stress & Burnout", // From "Stress"
      "Anxiety & Overthinking",
    ],
  },

  "therapist-24": {
    id: "therapist-24",
    displayId: "Therapist 24",
    name: "Shreya Verma",
    pronouns: "she/her",
    avatar: "/images/team/shreya-verma.jpg",
    qualifications: [
      {
        degree: "MA in Applied Psychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Weekdays",
        hours: "9 AM to 12 PM, 6 PM to 9 PM",
      },
      {
        days: "Weekends",
        hours: "12 PM to 5 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1200",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "800",
          max: "1000",
        },
      },
      priceRange: "1000-1500", // Chosen based on the majority of prices
      highestCharge: "1200",
    },
    bio: "Welcome! I strive to create a safe, supportive, and nonjudgmental space where you can openly express yourself. My approach is rooted in humanistic principles, emphasizing acceptance, empathy, and collaboration. Together, we will work on reducing distress, overcoming obstacles to growth, and building resilience. Using evidence-based techniques from Cognitive Behavioral Therapy (CBT), we will explore patterns of thought and behavior that may be holding you back and develop practical strategies to foster meaningful change. My goal is to empower you with the tools and insight needed to navigate challenges with confidence and clarity.",
    experience: 1,
    experienceRange: "1-2 years",
    specialization: [
      "Anxiety issues and depressive episodes",
      "Relationship concerns",
      "Emotional regulation and stress management",
      "Navigating changes in life and general distress",
      "Self-esteem issues",
      "Boosting confidence and fostering self compassion",
    ],
    contact: {
      email: "shreyology18@gmail.com ",
      phone: "+91 8756675511",
      linkedin:
        "https://www.linkedin.com/in/shreya-verma-300970267?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Anxiety issues and depressive episodes",
      "Relationship concerns",
      "Emotional regulation and stress management",
      "Navigating changes in life and general distress",
      "Self-esteem issues",
      "Boosting confidence and fostering self compassion",
    ],
    directConcernsTags: [
      "Anxiety & Overthinking", // From "Anxiety issues..."
      "Depression & Low Mood", // From "...depressive episodes"
      "Romantic Relationships", // From "Relationship concerns"
      "Familial Relationships", // From "Relationship concerns"
      "Friendships & Peer Concerns", // From "Relationship concerns"
      "Extreme Moods", // From "Emotional regulation..."
      "Stress & Burnout", // From "...stress management", "general distress"
      "Life Transitions", // From "Navigating changes in life..."
      "Self-Esteem & Confidence",
    ],
  },

  "therapist-25": {
    id: "therapist-25",
    displayId: "Therapist 25",
    name: "Ritika Jain",
    pronouns: "she/her",
    avatar: "/images/team/ritika-jain.png",
    qualifications: [
      {
        degree: "MSc in Clinical Psychology",
        institution: "",
      },
      {
        degree:
          "Level 1 training in BWRT, trained in BWRT specifically for grief work",
        institution: "",
      },
      {
        degree: "REBT",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Tuesday",
        hours: "12 PM to 7 PM",
      },
      {
        days: "Wednesday,Friday",
        hours: "12 PM to 8 PM",
      },
      {
        days: "Thursday",
        hours: "2 PM to 8 PM",
      },
      {
        days: "Saturday",
        hours: "12 PM to 5 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1200",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "800",
          max: "2000",
        },
      },
      priceRange: "1500-2000", // Covers both Working Professionals and Students
      highestCharge: "2000",
    },
    bio: "I’m Ritika Jain, a counselling psychologist with a Masters in Psychology and a clinical specialization. I am a certified primary child abuse respondent, first responder for suicide prevention, trauma-informed practitioner, and Level 1 BWRT practitioner. I specialize in helping clients navigate concerns such as depression, anxiety, stress, guilt, shame, self-worth, confidence, neurodivergence, grief, relationship challenges, and phobias. As a queer and neurodivergent individual myself, I am deeply committed to fostering inclusive and affirming therapeutic spaces. My lived experiences drive my dedication to creating environments where individuals feel safe, valued, and empowered to embrace their authentic selves. My approach to therapy is eclectic and integrates evidence-based practices like CBT and REBT with elements of Gestalt therapy, DBT, and therapeutic art coaching, ensuring each session is tailored to my clients’ unique needs. Rooted in a trauma and queer-affirmative lens, I strive to help clients navigate their challenges with clarity, resilience, and a renewed sense of autonomy.",
    experience: 1,
    experienceRange: "1-2 years",
    specialization: [
      "Relationship Concerns",
      "Anxiety",
      "Depression",
      "Trauma",
      "Grief",
      "Self-doubt",
      "Self-esteem",
      "Confidence",
      "Boundary Setting",
      "Phobias",
      "Fears",
      "Procastination",
      "Interpersonal Relationships",
      "clients who are queer",
      "neurodivergent",
      "Emotional Regulation",
    ],
    contact: {
      email: "mindloomtherapy@gmail.com",
      phone: "+91 6360872556",
      linkedin: "https://www.linkedin.com/in/ritika-jain-psychologist",

      location: "Indiranagar, Banglore",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Relationship Concerns",
      "Anxiety",
      "Depression",
      "Trauma",
      "Grief",
      "Self-doubt",
      "Self-esteem",
      "Confidence",
      "Boundary Setting",
      "Phobias",
      "Fears",
      "Procastination",
      "Interpersonal Relationships",
      "clients who are queer",
      "neurodivergent",
      "Emotional Regulation",
    ],
    directConcernsTags: [
      "Romantic Relationships", // From "Relationship Concerns", "Interpersonal Relationships"
      "Familial Relationships", // From "Relationship Concerns", "Interpersonal Relationships"
      "Friendships & Peer Concerns", // From "Relationship Concerns", "Interpersonal Relationships"
      "Anxiety & Overthinking", // From "Anxiety", "Phobias", "Fears"
      "Depression & Low Mood",
      "Trauma",
      "Grief & Loss",
      "Self-Esteem & Confidence", // From "Self-doubt", "Self-esteem", "Confidence"
      // "Boundary Setting" is a skill, not a category itself
      "Executive Functioning Difficulties", // From "Procrastination", often linked to neurodivergence
      "Gender Identity - related concerns", // From "clients who are queer"
      "Sexuality - related concerns", // From "clients who are queer"
      "Neurodivergence",
      "Extreme Moods",
    ],
    reviews: [
      {
        client: "",
        review:
          "I would like to express my sincere gratitude for Ritika Jain. I have been taking her guidance since August 2024. Its been a very good experience, she has patience and understanding towards her client and also gives very insightful techniques and methods to cope up for your situations. I would recommend Ritika to anyone who is seeking therapy , you will definitely see a change inside you.",
      },
    ],
  },

  "therapist-26": {
    id: "therapist-26",
    displayId: "Therapist 26",
    name: "Ananya Agarwal",
    pronouns: "she/her",
    avatar: "/images/team/ananya-agarwal.png",
    qualifications: [
      {
        degree: "MSc in Clinical Psychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday, Tuesday, Wednesday, Friday",
        hours: "8 PM to 9 PM",
      },
      {
        days: "Saturday",
        hours: "7 PM to 8 PM",
      },
      {
        days: "Sunday",
        hours: "12 PM, 3 PM, 5 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "Rs",
            duration: "50 mins",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "700",
          max: "1000",
        },
      },
      priceRange: "500-1000", // Covers both Working Professionals and Students
      highestCharge: "1000",
    },
    bio: "My work is grounded in an integrative, trauma-informed, and client-centered approach, meaning therapy is shaped around the unique needs and experiences each person brings into the room. I draw from Cognitive Behavioral Therapy (CBT), Dialectical Behavior Therapy (DBT), and Rational Emotive Behavior Therapy (REBT) while incorporating insights from mindfulness practices. Therapy with me is a collaborative process. Some sessions might focus on exploring patterns, thoughts, and emotions, while others may involve practical strategies to manage distress, build resilience, and improve relationships. I work with individuals navigating trauma, overwhelming emotions, self-esteem concerns, and relational challenges, creating a space that prioritizes safety, nonjudgment, and self-exploration. For those struggling with relationship challenges, therapy may involve understanding relational patterns, improving communication, and addressing emotional needs in romantic, familial, or friendship dynamics. Rather than imposing a rigid structure, I adapt my approach to balance deep reflection with actionable change, meeting clients where they are in their journey. At its core, my practice is about helping individuals feel more connected to themselves and their lives, with the tools and self-awareness to navigate challenges in a way that feels authentic and sustainable.  ",
    experience: 3,
    experienceRange: "3-4 years",
    specialization: [
      "Trauma",
      "Coping with Overwhelming Emotions and Impulsivity",
      "Substance Use and Addictive Behaviors",
      "Relationship Challenges (Romantic, Familial, and Friendships)",
      "Self-Esteem",
      "Body Image",
      "Identity Exploration",
    ],
    contact: {
      email: "therapywithananya@gmail.com",
      phone: "+91 8650505260",
      linkedin:
        "https://www.linkedin.com/in/ananya-a-283942134?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Coping with Overwhelming Emotions and Impulsivity",
      "Substance Use and Addictive Behaviors",
      "Relationship Challenges (Romantic, Familial, and Friendships)",
      "Self-Esteem",
      "Body Image",
      "Identity Exploration",
    ],
    directConcernsTags: [
      "Trauma",
      "Extreme Moods", // From "Coping with Overwhelming Emotions and Impulsivity"
      "Addiction & Coping Behaviors", // From "Substance Use and Addictive Behaviors", "Impulsivity"
      "Romantic Relationships",
      "Familial Relationships",
      "Friendships & Peer Concerns",
      "Self-Esteem & Confidence",
      "Body Image Concerns",
      "Identity Exploration",
    ],
  },
  "therapist-27": {
    id: "therapist-27",
    displayId: "Therapist 27",
    name: "Shree Goel",
    pronouns: "she/her",
    avatar: "/images/team/shree-geol.jpeg",
    qualifications: [
      {
        degree: " MA in Psychology (counselling)",
        institution: "",
      },
      {
        degree: "Diploma in Narrative Therapy and Community Work",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday to Friday",
        hours: "12 PM to 8 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1700",
            currency: "INR",
            location: "India",
          },
        },
        {
          individual: {
            amount: "2200",
            currency: "INR",
            location: "International",
          },
        },
      ],
      slidingScale: {
        availableFor: [
          "Students",
          "Individuals with limited paying capacity (unemployed or less income)",
        ],
        range: {
          min: "1000",
          max: "1700",
        },
      },
      priceRange: "1500-2000",
      highestCharge: "2200",
    },
    bio: `I am a caste, queer and neurodivergent affirmative practitioner. I draw from the narrative therapy along with the trauma-informed lens, which helps my clients express themselves without any fear of judgement or rejection. This 'no censor' expression and exploration eventually become the catalyst for healing and discovering their desired lives. I also believe that our relationship with ourselves is deeply impacted by the external world we live in, thus, I like to bring socio-cultural & political discourses into the therapeutic space. I aim to create in the therapy space what Hare-Mustin describes best, "the therapy room is a room lined with mirrors, reflecting back what is voiced within it".`,
    experience: 3,
    experienceRange: "3-4 years",
    specialization: [
      "Grief ",
      "Trauma ",
      "Life transitions ",
      "Gender identity and Body-image concerns",
      "Self-esteem and Self-exploration",
    ],
    contact: {
      email: "shreegoel.therapy@gmail.com",
      phone: "+91-9997993625",
      linkedin: "https://www.linkedin.com/in/shree-goel-73127717b/",
      instagram: "https://www.instagram.com/therapywithshree/",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Grief ",
      "Trauma ",
      "Life transitions ",
      "Gender identity and Body-image concerns",
      "Self-esteem and Self-exploration",
    ],
    directConcernsTags: [
      "Grief & Loss",
      "Trauma",
      "Life Transitions",
      "Gender Identity - related concerns",
      "Body Image Concerns",
      "Self-Esteem & Confidence",
      "Identity Exploration",
    ],
    reviews: [
      {
        client: "",
        review: `I really feel fascinated that you barely advised me on what to do or asked me to do this or that. I love your approach. You haven't just helped me solve a problem; you've trained my mind to think about situations from different perspectives. Which I feel is really beneficial because this skill will help me in the future too.

When we contact therapists, it's a common expectation that they will tell us what to do, and everything will be solved. I expected this too. But that hardly happened. What you did was bring up many perspectives on my thoughts, analyzing my thoughts. You never gave your opinion; you helped me think about another perspective by questioning my thoughts.

I felt so light after those sessions because I felt like I had solved something, obviously with your help, but it never felt like I was just following someone's advice blindly. Thank you so much for bringing up those positive sides that I never thought about, thank you for making me believe how worthy I am, how important my thoughts are. They may not align with others, but that doesn't mean they are wrong or I'm guilty. I have learned to prioritize my opinion.`,
      },
    ],
    blogs: ["exp-took-home"],
  },

  "therapist-28": {
    id: "therapist-28",
    displayId: "Therapist 28",
    name: "Pratiti Choudhury",
    pronouns: "she/her",
    avatar: "/images/team/pratiti.jpeg",
    qualifications: [
      {
        degree: "MA in Psychology (Psychosocio Clinical Studies)",
        institution: "",
      },
      {
        degree: "Certified Trauma Informed Practitioner ",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Sunday",
        hours: "Prior Appointment only",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "INR",
            duration: "session",
          },
        },
      ],
      slidingScale: {
        availableFor: ["need based"],
        range: {
          min: "500",
          max: "1000",
        },
      },
      priceRange: "1000-1500",
      highestCharge: "1000",
    },
    bio: "I am a psychodynamically oriented, trauma-informed psychotherapist. I aim to create a supportive, collaborative space to explore identity, relationships, trauma, anxiety, and self-esteem. Having faced my own mental health struggles, I value clients’ agency and view the therapeutic relationship as a key space for healing. I also align with a humanistic-existential lens and a psychosocial approach that honors cultural, gender, caste, class, and religious diversities.",
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Trauma",
      "Familial Relationships",
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
    ],
    contact: {
      email: "therapywithpratiti@gmail.com",
      phone: "+91 8882818528",
      location: "Greh Pravesh Therapy & Healing Centre / Online ",
      linkedin:
        "https://www.linkedin.com/in/pratiti-choudhury-aa05b9232?trk=public_profile_samename-profile&originalSubdomain=in",
    
    },
    languages: ["English", "Hindi", "Assamese"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Familial Relationships",
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
    ],
    directConcernsTags: [
      "Trauma",
      "Familial Relationships",
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
    ],
    reviews: [
      {
        client: "",
        review:
          "I've been taking sessions with Pratiti and talking and exploring my challenges never felt more safe and comfortable. I truly appreciate how keenly she responds and understands my issues and I feel glad that I could find someone with whom this process feels less daunting and more encouraging.",
      },
      {
        client: "",
        review:
          "I took my therapy session with Pratiti and it was so enlightening for me and helped me cope with the distress.",
      },
      {
        client: "",
        review:
          "I am so incredibly glad I started sessions with Pratiti as my counsellor in February. While I still have a long way to go on my journey, Pratiti has consistently made me feel heard and understood. The way she addresses my issues is incredibly effective, and her ability to make me understand complex things is truly remarkable - she makes it all so easy to grasp. She's incredibly flexible and validating with every emotion I bring to our sessions. I absolutely intend to keep her as my therapist for a very long time. Highly, highly recommend!",
      },
    ],
  },

  "therapist-29": {
    id: "therapist-29",
    displayId: "Therapist 29",
    name: "Soumya Mishra",
    pronouns: "she/her",
    avatar: "/images/team/soumya-mishra.jpg",
    qualifications: [
      {
        degree: "MA Counselling psychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday-Friday",
        hours: "12:00 OM - 7:00 PM",
      },
      {
        days: "Saturday",
        hours: "10:00 AM - 2:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "INR",
            duration: "session",
          },
        },
      ],
      slidingScale: {
        availableFor: ["Students and unemployed individuals"],
        range: {
          min: "300 (for students) | 500 (Non working individuals)",
          max: "500 (for students) | 800 (Non working individuals)",
        },
      },
      priceRange: "500-1000",
      highestCharge: "1000",
    },
    bio: "Therapy with me is a space where you can show up just as you are—confused, overwhelmed, curious, or quiet. You don’t need to have the right words or a plan. We’ll move at your pace, you’ll be supported throughout, and we’ll pause when things get heavy. I’ll bring in ideas that fit you, always checking in along the way. You won’t be rushed or pushed. This is your space to breathe, feel, and be. We’ll start wherever you are, and go from there, together.",
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Stress & Burnout",
      "Self-Esteem & Confidence",
      "Career & Academic Stress",
    ],
    contact: {
      email: "m.saumya022@gmail.com",
      phone: "+91-8766267202",
      location: "Delhi",
      linkedin: "https://in.linkedin.com/in/mishrasaumya",
      instagram: "https://www.instagram.com/untangleknots",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Stress & Burnout",
      "Self-Esteem & Confidence",
      "Career & Academic Stress",
    ],
    directConcernsTags: [
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Stress & Burnout",
      "Self-Esteem & Confidence",
      "Career & Academic Stress",
    ],
  },

  "therapist-30": {
    id: "therapist-30",
    displayId: "Therapist 30",
    name: "Vasundhra Choudhary",
    pronouns: "she/her",
    avatar: "/images/team/vasundhra-choudhary.jpeg",
    qualifications: [
      {
        degree: "MA in Psychology",
        institution: "",
      },
      {
        degree: "Professional Diploma in  Clinical Psychology (RCI Registered)",
        institution: "",
      },
      {
        degree: "Trauma informed care",
        institution: "",
      },
      {
        degree: "Clinical Psychology,",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday, Friday",
        hours: "12:00 PM - 09:00 PM",
      },
      {
        days: "Tuesday",
        hours: "12:00 PM - 7:30 PM",
      },
      {
        days: "Sunday",
        hours: "09:00 AM - 09:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "2000",
            currency: "INR",
            duration: "session",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "1000",
          max: "1200",
        },
      },
      priceRange: "1500-2000",
      highestCharge: "2000",
    },
    bio: "I work with children, young adults, and adults, addressing a wide range of clinical concerns, including diagnosis, assessment, and intervention for diverse populations. In addition to clinical cases, I also help individuals navigate challenges related to self-management, self-esteem, work-life integration, and productivity. Trained in Cognitive Behavioral Therapy (CBT), Dialectical Behavior Therapy (DBT), and Acceptance and Commitment Therapy (ACT), I integrate evidence-based techniques tailored to each client's needs. As a certified yoga teacher, I incorporate mindfulness and body-based practices into therapy, fostering a holistic approach to healing. I also emphasize the role of nutrition in mental well-being, recognizing its impact on overall health. My therapeutic space is inclusive, affirming, and non-judgmental, ensuring that clients feel safe to explore, heal, and grow. I work collaboratively with each individual, helping them embrace their authentic selves and cultivate lasting well-being.",
    experience: 3,
    experienceRange: "3-4 years",
    specialization: [
      "Child Population",
      "Body image Issues",
      "Self-esteem Issues",
    ],
    contact: {
      email: "Vasundhrac20@gmail.com",
      phone: "+91-8130032490",
      linkedin: "https://www.linkedin.com/in/vasundhra-c-43b761117/",
      instagram: "",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy", "couples-therapy"],
    concerns: ["Child Population", "Body image Issues", "Self-esteem Issues"],
    directConcernsTags: [
      "Body Image Concerns",
      "Self-Esteem & Confidence",
      "Anxiety & Overthinking", // Common in children
      "Familial Relationships", // Often central for children
      "Friendships & Peer Concerns",
    ],
  },
  "therapist-31": {
    id: "therapist-31",
    displayId: "Therapist 31",
    name: "Shivangi Khangarot",
    pronouns: "she/her",
    avatar: "/images/team/shivangi-khangarot.jpeg",
    qualifications: [
      {
        degree: "MSc. Psychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday to Friday",
        hours: "11:00 AM - 07:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1200",
            currency: "INR",
            duration: "45-60 mins",
          },
        },
        {
          couples: {
            amount: "2000",
            currency: "INR",
            duration: "60-90 mins",
          },
        },
      ],
      slidingScale: {
        availableFor: ["students"],
        range: {
          min: "1000",
          max: "1200",
        },
      },
      priceRange: "1500-2000",
      highestCharge: "2000",
    },
    bio: "I'm here to support you on your journey, whether you're seeking individual or couples therapy. As a client-centered therapist, I'm committed to understanding your unique needs and goals. We'll work collaboratively to create a safe, non-judgmental space for exploration and growth. My therapy sessions are experiential in nature, I like to give privilege to your emotions, values, and personal experiences. I draw from various evidence-based therapies, including Emotionally Focused Therapy (EFT) and Mindfulness-Based Therapy. As a couples therapist, I help partners build stronger, more resilient relationships. Using EFT, I support couples in navigating conflicts, deepening emotional intimacy, and fostering a more secure attachment. I also specialize in working with trauma and shame, recognizing the profound impact these experiences can have on one's life. I strive to create a compassionate and understanding environment where you feel safe exploring these complex emotions. Together, we'll work to develop coping strategies, reframe negative self-narratives, and cultivate self-acceptance and self-compassion. As someone who's passionate about trauma-informed care, I'm constantly learning and growing to better support you. My aim is to empower you with the tools, insights, and compassion needed to navigate life's challenges and cultivate a deeper connection with yourself and others. You're the expert in your life, and I'm here to support and empower you. Let's work together to unlock your full potential.",
    experience: 2,
    experienceRange: "2-3 years",
    specialization: [
      "Shame and Guilt",
      "Trauma and Stress",
      "Procrastination",
      "Body image Issues",
      "Interpersonal Relationships Issues (friendships, romantic relationships)",
      "Couples Therapy",
    ],
    contact: {
      email: "therapywithshivangi@gmail.com",
      phone: "+91-9975474159",
      location: "Online",
      linkedin:
        "https://www.linkedin.com/in/shivangi-khangarot?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
      instagram:
        "https://www.linkedin.com/in/shivangi-khangarot?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy", "couples-therapy", "family-therapy"],
    concerns: [
      "Shame and Guilt",
      "Trauma and Stress",
      "Procrastination",
      "Body image Issues",
      "Interpersonal Relationships Issues (friendships, romantic relationships)",
      "Couples Therapy",
    ],
    directConcernsTags: [
      "Self-Esteem & Confidence", // "Shame and Guilt" often deeply impact self-esteem
      "Trauma", // From "Trauma and Stress"
      "Stress & Burnout", // From "Trauma and Stress"
      "Executive Functioning Difficulties", // From "Procrastination"
      "Body Image Concerns",
      "Friendships & Peer Concerns", // From "Interpersonal Relationships Issues (friendships...)"
      "Romantic Relationships",
    ],
    reviews: [
      {
        client: "Samiksha Virmani",
        review:
          "Shivangi has been incredibly supportive and understanding. I always feel heard and safe during our sessions. Their guidance has really helped me grow and manage things better. Highly recommend!",
      },
      {
        client: "Manya Jain",
        review:
          "Shivangi is an excellent therapist. A very good listener with a perfect balance of empathy , humour and guidance.  I was hesitant about the outcomes of therapy, but sessions with her made me want to continue and see the positive effects of it.",
      },
      {
        client: "Khushi Arora",
        review:
          "My first therapy experience was with Shivangi. Very sceptical despite being a psychology student but it was a good start. I’m glad the sessions helped me and I am glad I started them with her.",
      },
      {
        client: "N",
        review: `
         It's been an year since I have been associated with Shivangi Ma'am,  she is not only a well trained therapist but a wonderful human being! Shivangi Ma'am keep up with my pace, is able to focus on details so clearly, it's simply amazing! Sometimes we come with a different issue but the root cause lie elsewhere in our unhealed wounds! She helped me sail through the most difficult phase of my life, not only that, she helped me navigate my thoughts and channelise my energy in right direction! I am most grateful that i got to know Shivangi Ma'am! She is honest, kind and warm and yet manage to be professional!!
        `,
      },
      {
        client: "Vidhi Jain",
        review:
          "Therapy has felt like a safe space to me. Shivangi has always made me feel heard. I could share anything, without ever being felt judged.",
      },
      {
        client: "Varnika Jain",
        review:
          "My therapist is shivangi mam and she is a very empathetic person, I was very anxious about what therapy feels like but she has been handling that very well and she has been very helpful.",
      },
    ],
  },

  "therapist-32": {
    id: "therapist-32",
    displayId: "Therapist 32",
    name: "Saakshi Arya",
    pronouns: "she/her",
    avatar: "/images/team/saakshi-arya.jpg",
    qualifications: [
      {
        degree: "MA in Counselling Psychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday-Friday",
        hours: "10 AM to 7 PM",
      },
      {
        days: "Saturday",
        hours: "10 AM to 1 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1500",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "1500",
          max: "1000",
        },
      },
      priceRange: "1000-1500", // Chosen based on the majority of prices
      highestCharge: "1500",
    },
    bio: "My approach to Therapy is very Decolonised and client centred. This means that we collaborate to find accessible solutions, coregulate to deal with struggles and difficulties in life, acknowledge and navigate systemic oppression and discrimination.  \n We follow the pace of what clients need. Along with that, I hold an eclectic approach, which means I tailor my approach according to the needs of a client. Somatic practices are something I'm incorporating recently, especially when supporting clients dealing with trauma. \n My approach is neurodivergence inclusive as well as queer affirmative. ",
    experience: 2,
    experienceRange: "2-3 years",
    specialization: [
      "Trauma",
      "Grief & Loss",
      "Stress & Burnout",
      "Sexuality - related concerns",
      "Neurodivergence",
      "Individual Therapy",
      "Couples Therapy",
    ],
    contact: {
      email: "aryasaakshi911@gmail.com",
      phone: "+91 9873218275",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy", "couples-therapy"],
    concerns: [
      "Trauma",
      "Grief & Loss",
      "Stress & Burnout",
      "Sexuality - related concerns",
      "Neurodivergence",
      "Individual Therapy",
      "Couples Therapy",
    ],
    directConcernsTags: [
      "Trauma",
      "Grief & Loss",
      "Stress & Burnout",
      "Sexuality - related concerns",
      "Neurodivergence",
    ],
  },

  "therapist-33": {
    id: "therapist-33",
    displayId: "Therapist 33",
    name: "Karishma Desai Shah",
    pronouns: "she/her",
    avatar: "/images/team/karishma-desai.jpeg",
    qualifications: [
      {
        degree: "MA in Lifespan Counselling",
        institution: "",
      },
      {
        degree: "PG Diploma in Counselling accredited by COSCA",
        institution: "",
      },
      {
        degree: "Diploma in Arts Based Therapy",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Wednesday-Friday",
        hours: "9 AM to 8 PM",
      },
      {
        days: "Saturday",
        hours: "9 AM to 5 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1500",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "500",
          max: "1500",
        },
        availableFor: [
          "Students",
          "Non-working individuals without monetary support",
        ],
      },
      priceRange: "1000-1500", // Chosen based on the majority of prices
      highestCharge: "1500",
    },
    bio: "Drawing from person-centred and psychodynamic approaches, I create a flexible and non-judgmental space tailored to your needs. I work from a client-centric perspective to design a space around my client's neeeds, rather than my client having to fit into a fixed structure. Our relationship is the foundation of healing, and together, we'll explore your patterns and life experiences to foster greater insight and awareness. I believe that awareness is a powerful catalyst for change and empowerment. With a commitment to social justice, I'm dedicated to understanding the complexities of power and difference in our world. Through my intentional presence, skills, and genuine approach, I'll work with you to establish a safe and supportive relationship, empowering you to navigate life's challenges and promote personal growth.",
    experience: 2,
    experienceRange: "2-3 years",
    specialization: [
      "Familial Relationships",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Self-Esteem & Confidence",
      "Identity Exploration",
    ],
    contact: {
      email: "karishma.nimitt@gmail.com",
      phone: "+91 7874654886",
      location: "Ahemdabad, Gujrat",
      linkedin: "http://www.linkedin.com/in/karishma-desai-she-her",
      instagram:
        "https://www.instagram.com/nimitt.counselling?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
    },
    languages: ["English", "Hindi", "Gujrati"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Familial Relationships",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Self-Esteem & Confidence",
      "Identity Exploration",
    ],
    directConcernsTags: [
      "Familial Relationships",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Self-Esteem & Confidence",
      "Identity Exploration",
    ],
  },

  "therapist-34": {
    id: "therapist-34",
    displayId: "Therapist 34",
    name: "Manoj T",
    pronouns: "he/him",
    avatar: "/images/team/manoj-t.png",
    qualifications: [
      {
        degree: "MSc Counselling Psychology",
        institution: "",
      },

      {
        degree: "MSc Cognitive Neuroscience and Neuropsychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Thursday/Friday/Saturday",
        hours: "7 PM to 9 PM",
      },
      {
        days: "Wednesday",
        hours: "10 AM to 8 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "2000",
            currency: "Rs",
          },
          couples: {
            amount: "3500",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: " ",
          max: " ",
        },
        availableFor: [" "],
      },

      priceRange: "2000+", // Chosen based on the majority of prices
      highestCharge: "3500",
    },
    bio: "With 3 years of experience in the Mental Health field, my therapy space offers a warm, supportive environment to explore what’s going on beneath the surface. Rooted in Interpersonal principles and informed by Neuroscience, my approach helps you understand how your relationships, emotions, and patterns are connected. Whether you’re facing challenges in love, work, or within yourself, my therapy meets you with empathy, curiosity, and thoughtful guidance that fits where you are.",
    experience: 3,
    experienceRange: "3-4 years",
    specialization: [
      "Trauma",
      "Grief & Loss",
      "Romantic Relationships",
      "Self-Esteem & Confidence",
      "Perfectionism",
    ],
    contact: {
      email: "manoj.boxofmail@gmail.com",
      phone: "+91 6362382640",
      linkedin: "http://www.linkedin.com/in/manoj-t-253b9b153",
    },
    languages: ["English", "Tamil"],
    serviceIds: ["individual-therapy", "couples-therapy"],
    concerns: [
      "Trauma",
      "Grief & Loss",
      "Romantic Relationships",
      "Self-Esteem & Confidence",
      "Perfectionism",
    ],
    directConcernsTags: [
      "Trauma",
      "Grief & Loss",
      "Romantic Relationships",
      "Self-Esteem & Confidence",
      "Perfectionism",
    ],
  },

  "therapist-35": {
    id: "therapist-35",
    displayId: "Therapist 35",
    name: "Maya Sen",
    pronouns: "she/her",
    avatar: "/images/team/maya-sen.jpeg",
    qualifications: [
      {
        degree: "Masters in Narrative Therapy and Community Work",
        institution: "",
      },
      {
        degree: "Masters in Social Work in Mental Health ",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Friday,Saturday",
        hours: "10 AM to 6 PM",
      },
      {
        days: "Sunday",
        hours: "10 AM to 4 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "800",
          max: "1000",
        },
      },
      priceRange: "1000-1500", // Chosen based on the majority of prices
      highestCharge: "1500",
    },
    bio: "I offer counselling that centers each client’s experiences, values, and voice. I mainly work with adults. My approach is grounded in narrative therapy and social justice, and is trauma-informed, queer-affirmative, and neurodiversity-affirming. I believe many mental health concerns are shaped by systemic forces, yet people are often made to feel the problem lies within. Still, people are always finding powerful ways to resist. I walk alongside clients to honor these stories and co-create lives that center what truly matters to them.",
    experience: 6,
    experienceRange: "4+ years",
    specialization: [
      "Trauma",
      "Romantic Relationships",
      "Friendships & Peer Concerns",
      "Stress & Burnout",
      "Identity Exploration",
    ],
    contact: {
      email: "ms.maya.sen@gmail.com",
      phone: "+91 9830740206",
      location:
        "35 Panditia Road. Flat 3A. Kolkata 19. Pallazzo building, Kolkata / Online",
    },
    languages: ["English", "Bengali"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Romantic Relationships",
      "Friendships & Peer Concerns",
      "Stress & Burnout",
      "Identity Exploration",
    ],
    directConcernsTags: [
      "Trauma",
      "Romantic Relationships",
      "Friendships & Peer Concerns",
      "Stress & Burnout",
      "Identity Exploration",
    ],
  },

  "therapist-36": {
    id: "therapist-36",
    displayId: "Therapist 36",
    name: "Ishika Mehta",
    pronouns: "she/her",
    avatar: "/images/team/ishika-mehta.jpg",
    qualifications: [
      {
        degree: "MSC COUNSELLING PSYCHOLOGY",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday-Friday",
        hours: "11 AM to 8 PM",
      },
      {
        days: "Saturday",
        hours: "11 AM to 3 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1300",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "1000",
          max: "1300",
        },
      },
      priceRange: "1000-1500", // Chosen based on the majority of prices
      highestCharge: "1500",
    },
    bio: "I am Ishika Mehta (she/her), a Counselling psychologist under supervision, with a Masters in Counselling Psychology from Christ University, Delhi. In therapy, I work with clients in the age range of 19-35 years, where we work collaboratively to understand the individual and their world, while incorporating a trauma sensitive and multicultural lens. My approach that attends to the importance of relationships and how it impacts one's experience with self and the world suggests inclination towards attachment and systems oriented framework, as well as cognitive theories.",
    experience: 1,
    experienceRange: "1-2 years",
    specialization: [
      "Trauma",
      "Grief & Loss",
      "Romantic Relationships",
      "Familial Relationships",
      "Self-Esteem & Confidence",
    ],
    contact: {
      email: "ishika.mentalhealth@gmail.com",
      phone: "+91 9811557414",
      location: "Delhi",
      linkedin:
        "https://www.linkedin.com/in/ishika-mehta-94312b1b5?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      instagram:
        "https://www.instagram.com/mentalhealthwithishika?igsh=anNodHNxa2JtNGpp",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Grief & Loss",
      "Romantic Relationships",
      "Familial Relationships",
      "Self-Esteem & Confidence",
    ],
    directConcernsTags: [
      "Trauma",
      "Grief & Loss",
      "Romantic Relationships",
      "Familial Relationships",
      "Self-Esteem & Confidence",
    ],
  },
  "therapist-37": {
    id: "therapist-37",
    displayId: "Therapist 37",
    name: "Lavi Jain",
    pronouns: "she/her",
    avatar: "/images/team/lavi-jain.PNG",
    qualifications: [
      {
        degree: "MSc Clinical Psychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Sunday",
        hours: "11 AM to 8 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "500",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "500",
          max: "500",
        },
      },
      priceRange: "0-500", // Chosen based on the majority of prices
      highestCharge: "500",
    },
    bio: "I have started taking pro-bono therapy sessions under supervision. My therapeutic approach is trauma-informed and rooted in empathy, active listening, and creating a safe, non-judgmental space for clients. \n  I deeply value holding space for others, allowing them to feel seen, heard, and validated. I draw from person-centered, relational, and mindfulness-based approaches, giving relaxation therapies like guided imagery and JPMR and adapting my work based on the needs of the person in front of me. Building trust and connection is central to how I work.",
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Romantic Relationships",
      "Depression & Low Mood",
      "Stress & Burnout",
      "Self-Esteem & Confidence",
      "Career & Academic Stress",
    ],
    contact: {
      email: "lavijain.ut@gmail.com",
      phone: "+91 7082875230",
      location: "Delhi ",
      linkedin:
        "https://www.linkedin.com/in/lavi-jain-8baba3214?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Romantic Relationships",
      "Depression & Low Mood",
      "Stress & Burnout",
      "Self-Esteem & Confidence",
      "Career & Academic Stress",
    ],
    directConcernsTags: [
      "Romantic Relationships",
      "Depression & Low Mood",
      "Stress & Burnout",
      "Self-Esteem & Confidence",
      "Career & Academic Stress",
    ],
    probono: true,
  },

  "therapist-38": {
    id: "therapist-38",
    displayId: "Therapist 38",
    name: "Riya Mitra",
    pronouns: "she/her",
    avatar: "/images/team/riya-mitra.jpg",
    qualifications: [
      {
        degree: "MSc in Clinical Psychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Friday",
        hours: "9 AM to 7 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "600",
          max: "800",
        },
      },
      priceRange: "500-1000", // Chosen based on the majority of prices
      highestCharge: "1000",
    },
    bio: "Hey there!🌷 \n I’ve recently begun my practice as a Counselling Psychologist, holding space for people as they navigate their inner worlds. My approach is rooted in person-centred therapy, grounded in empathy, authenticity, and deep respect for each individual’s lived experience.  \n I have extensive experience understanding and researching individuals facing challenges such as Identity Exploration, Grief and Loss.  \n I look forward to the opportunity to collaborate with and support you on your path to mental health. Feel free to reach out, and let's begin this journey together.",
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Trauma",
      "Grief & Loss",
      "Stress & Burnout",
      "Identity Exploration",
      "Life Transitions",
    ],
    contact: {
      email: "intherapywithriya@gmail.com",
      phone: "+91 9971350994",
      location: "Noida, Uttar Pradesh",

      linkedin: "https://www.linkedin.com/in/riya-mitra-8b75b4214",
      instagram:
        "https://www.instagram.com/nimitt.counselling?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
    },
    languages: ["English", "Hindi", "Bengali"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Grief & Loss",
      "Stress & Burnout",
      "Identity Exploration",
      "Life Transitions",
    ],
    directConcernsTags: [
      "Trauma",
      "Grief & Loss",
      "Stress & Burnout",
      "Identity Exploration",
      "Life Transitions",
    ],
  },

  "therapist-39": {
    id: "therapist-39",
    displayId: "Therapist 39",
    name: "Ami Patel",
    pronouns: "she/her",
    avatar: "/images/team/ami-patel.jpeg",
    qualifications: [
      {
        degree: "MA Clinical Psychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Friday",
        hours: "10 AM to 8 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "2000",
            currency: "Rs",
            location: "India",
            duration: "55 mins",
          },
          couples: {
            amount: "3000",
            currency: "Rs",
            location: "India",
            duration: "55 mins",
          },
        },
      ],
      slidingScale: {
        availableFor: ["Students"],
        range: {
          min: "1500",
          max: "1800",
        },
      },
      priceRange: "1500-2000", // Chosen based on the majority of prices
      highestCharge: "3000",
    },
    bio: "I believe therapy should be as unique as the person seeking it, shaped by their individual experiences and needs. My approach is eclectic, grounded in a strong trauma-informed lens through extensive training. Above all, I want you to feel safe—both in the therapy space and in your own body. From the very first session, I aim to build a relationship based on honesty, respect, and equality. We’ll start with a simple check-in to ease in, and my hope is that you leave feeling heard, understood, and supported.",
    experience: 6,
    experienceRange: "4+ years",
    specialization: [
      "Trauma",
      "Grief & Loss",
      "Stress & Burnout",
      "Identity Exploration",
      "Life Transitions",
    ],
    contact: {
      email: "amipsychotherapist@gmail.com",
      phone: "+91 8369852066",
      location: "Pune, Online",

      linkedin:
        "https://www.linkedin.com/in/ami-patel-9917611a4?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
      instagram:
        "https://www.instagram.com/tru.amigo?igsh=MWUxZjQyNndhbmZseg%3D%3D&utm_source=qr",
    },
    languages: ["English", "Hindi", "Gujrati"],
    serviceIds: ["individual-therapy", "couples-therapy", "family-therapy"],
    concerns: [
      "Trauma",
      "Romantic Relationships",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Body Image Concerns",
    ],
    directConcernsTags: [
      "Trauma",
      "Romantic Relationships",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Body Image Concerns",
    ],

    reviews: [
      {
        client: "",
        review:
          "I honestly don’t know where I’d be without Ami Patel. When I started therapy, I was really stuck dealing with depression and emotional eating, and not understanding why I felt so overwhelmed all the time. From the first session, she made me feel safe, like I didn’t have to hide or explain everything perfectly. \n She helped me connect things I’d never thought about .like how my body was holding onto old stuff I hadn’t fully processed. It wasn’t just about talking it was about slowing down, feeling things at my own pace, and learning how to be kind to myself. \n I’ve come a long way. I feel lighter, more in control, and way more compassionate toward myself. I’m so grateful I found someone who really gets trauma and holds space with so much care.",
      },
    ],
  },
  "therapist-40": {
    id: "therapist-40",
    displayId: "Therapist 40",
    name: "Nidhi Goswami",
    pronouns: "she/her",
    avatar: "/images/team/nidhi-goswami.jpg",
    qualifications: [
      {
        degree: "MSc Mental Health Studies",
        institution: "",
      },
      {
        degree: "Certificate Course in Solution-Focused Brief Therapy (SFBT)",
        institution: "",
      },
      {
        degree: "Trauma-Informed Practice Training ",
        institution: "",
      },
      {
        degree: "Applied Suicide Intervention Skills Training",
        institution: "",
      },
      {
        degree: "Transactional Analysis 101",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Saturday",
        hours: "10 AM to 8 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "800",
          max: "1000",
        },
      },
      priceRange: "500-1000", // Chosen based on the majority of prices
      highestCharge: "1000",
    },
    bio: "My approach is person-centered, trauma-informed, and culturally sensitive. I work integratively, drawing from cognitive and mindfulness-based practices, narrative therapy, and solution-focused therapy. We’ll shape the space together in a way that feels safe and supportive to you. You can expect a steady, compassionate presence and a space where we can begin to make sense of whatever you're carrying, at your pace.",
    experience: 2,
    experienceRange: "2-3 years",
    specialization: [
      "Grief & Loss",
      "Romantic Relationships",
      "Familial Relationships",
      "Anxiety & Overthinking",
      "Career & Academic Stress",
    ],
    contact: {
      email: "perchMH@gmail.com",
      phone: "+91 8511115236",
      location: "Online",
      linkedin: "http://linkedin.com/in/nidhi83",
      instagram:
        "https://www.instagram.com/perch_mentalhealth?igsh=MTV5dDdzbnJ5OG02dg%3D%3D&utm_source=qr",
    },
    languages: ["English", "Hindi", "Gujrati", "Marathi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Grief & Loss",
      "Romantic Relationships",
      "Familial Relationships",
      "Anxiety & Overthinking",
      "Career & Academic Stress",
    ],
    directConcernsTags: [
      "Grief & Loss",
      "Romantic Relationships",
      "Familial Relationships",
      "Anxiety & Overthinking",
      "Career & Academic Stress",
    ],
  },

  "therapist-41": {
    id: "therapist-41",
    displayId: "Therapist 41",
    name: "Ashmita Dey",
    pronouns: "she/her",
    avatar: "/images/team/ashmita-dey.jpeg",
    qualifications: [
      {
        degree: "M.Sc. Psychology ",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Friday",
        hours: "7:15 PM - 8:15 PM",
      },
      {
        days: "Monday - Friday",
        hours: "8:30 PM - 9:30 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "600",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "0",
          max: "500",
        },
        availableFor: ["Yes"],
      },
      priceRange: "500-1000", // Chosen based on the majority of prices
      highestCharge: "600",
    },
    bio: `I take an emotion-focused, client-centered approach to therapy, offering a safe space to explore emotions, process experiences, and navigate challenges. Our work will be guided by Emotion-Focused Therapy (EFT), with techniques from CBT and Narrative Therapy based on your needs. Together, we’ll reflect, build insight, and develop coping strategies while nurturing self-compassion and acceptance. You have your own story, and I’m here to support you in making sense of it—one step at a time.`,
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Trauma",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Stress & Burnout",
      "Identity Exploration",
    ],
    contact: {
      email: "deyashmita02@gmail.com",
      phone: "+919830148039",
      location: "Hyderabad,Online",
      linkedin: "https://www.linkedin.com/in/ashmita-dey-9bb376201/",
    },
    languages: ["English", "Hindi", "Bengali"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Stress & Burnout",
      "Identity Exploration",
    ],
    directConcernsTags: [
      "Trauma",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Stress & Burnout",
      "Identity Exploration",
    ],
  },

  "therapist-42": {
    id: "therapist-42",
    displayId: "Therapist 42",
    name: "Abhya Sharma",
    pronouns: "she/her",
    avatar: "/images/team/abhya-sharma.jpg",
    qualifications: [
      {
        degree: "Professional Diploma in Clinical Psychology",
        institution: "",
      },
      {
        degree:
          "Core Skills training in Existential-Humanistic therapy from EHI, California",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Saturday",
        hours: "10 AM to 8 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1800",
            currency: "Rs",
            location: "India",
          },
        },
        {
          individual: {
            amount: "2400",
            currency: "Rs",
            location: "International",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "",
          max: "",
        },
        availableFor: ["Currently Unavailable"],
      },
      priceRange: "1500-2000", // Chosen based on the majority of prices
      highestCharge: "1800",
    },
    bio: "My work with my clients is depth and exploration-focused. While it helps to label, my focus is a lot more on understanding the human behind the label, be it diagnostic or otherwise. I strongly believe that each of us has the ability to heal, grow and live a life that feels authentic to us, and my work as a therapist is to hold up a mirror to the roadblocks that are preventing my clients from doing so and help do away with them. The therapeutic modalities I incorporate into my work include Existential-Humanistic, Psychodynamic and Emotion-focused Therapy. ",
    experience: 4,
    experienceRange: "4+ years",
    specialization: [
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Self-Esteem & Confidence",
      "Perfectionism",
      "Addiction & Coping Behaviors",
    ],
    contact: {
      email: "therapywithabhya@gmail.com",
      phone: "+919811714856",
      location:
        "Narrative Couch: E Block, Sector 63, Noida, Hazratpur Wajidpur, Uttar Pradesh 201301",
      linkedin: "http://www.linkedin.com/in/abhya-sharma-55236019b",
      instagram:
        "https://www.instagram.com/the_voice_of_a_therapist?igsh=aHhmN3BpenI3aGdi",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Self-Esteem & Confidence",
      "Perfectionism",
      "Addiction & Coping Behaviors",
    ],
    directConcernsTags: [
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Self-Esteem & Confidence",
      "Perfectionism",
      "Addiction & Coping Behaviors",
    ],
  },

  "therapist-43": {
    id: "therapist-43",
    displayId: "Therapist 43",
    name: "Supreet Kaur",
    pronouns: "she/her",
    avatar: "/images/team/supreet-kaur.jpg",
    qualifications: [
      {
        degree: "MA in Psychology",
        institution: "",
      },
      {
        degree: "Post Graduate Diploma in Guidance and Counselling",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Saturday",
        hours: "11 AM to 7 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "800-1000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "500",
          max: "700",
        },
        availableFor: ["Students and Individuals who are in financial need."],
      },
      priceRange: "500-1000", // Chosen based on the majority of prices
      highestCharge: "1000",
    },
    bio: "I offer individual therapy in a warm, collaborative space where you're encouraged to show up as you are. My approach is client-centered and integrative, which means we’ll tailor our work to your needs, goals, and pace. I draw from CBT, SFBT, and DBT-inspired tools to help with patterns like overthinking, low mood, or burnout. Therapy with me is grounded in empathy, curiosity, and the belief that meaningful change happens when you feel safe and supported. Together, we’ll explore what’s weighing you down and gently move toward clarity, growth, and self-trust.",
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Stress & Burnout",
      "Self-Esteem & Confidence",
      "Career & Academic Stress",
    ],
    contact: {
      email: "mannmatters.space@gmail.com",
      phone: "+919259810678",
      location: "Online",
      instagram:
        "https://www.instagram.com/mannmatters.in?igsh=bmtodGk4dTkxbjRq",
      linkedin:
        "https://www.linkedin.com/in/supreet-kaur-66578b232?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Self-Esteem & Confidence",
      "Perfectionism",
      "Addiction & Coping Behaviors",
    ],
    directConcernsTags: [
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Self-Esteem & Confidence",
      "Perfectionism",
      "Addiction & Coping Behaviors",
    ],
    probono: true,
  },

  "therapist-44": {
    id: "therapist-44",
    displayId: "Therapist 44",
    name: "Vidhi Diwani",
    pronouns: "she/her",
    avatar: "/images/team/vidhi.jpg",
    qualifications: [
      {
        degree: "M.A. in Psychology (Counselling) ",
        institution: "",
      },
      {
        degree: "QPR Suicide Gatekeeper",
        institution: "",
      },
      {
        degree: "Certificate course in Trauma Informed Therapy ",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Tuesday - Sunday",
        hours: "10 AM to 7 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "800-1000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "600",
          max: "800",
        },
        availableFor: ["Students"],
      },
      priceRange: "500-1000", // Chosen based on the majority of prices
      highestCharge: "900",
    },
    bio: "In the therapeutic space, you can expect a collaborative effort where your story is met with curiosity, care and respect. My role is to walk alongside you and hold space for your experiences while honouring your autonomy. I welcome and affirm the full spectrum of who you are including your identity, your history, your ways of thinking and feeling which are shaped by systems of power, trauma, neurodivergence, and queer experiences. Together, we will create a space where growth and reflection are supported, and where healing can be reimagined in ways that feel right and meaningful to you. ",
    experience: 1,
    experienceRange: "1-2 years",
    specialization: [
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Stress & Burnout",
      "Self-Esteem & Confidence",
      "Body Image Concerns",
    ],
    contact: {
      email: "therapywithvidhi@gmail.com ",
      phone: "+919082577430",
      location: "Online",
      instagram: "https://www.instagram.com/loopedandlayered/",
      linkedin:
        "https://www.linkedin.com/in/vidhi-diwani-386191269?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    languages: ["English", "Hindi", "Gujrati"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Stress & Burnout",
      "Self-Esteem & Confidence",
      "Body Image Concerns",
    ],
    directConcernsTags: [
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Stress & Burnout",
      "Self-Esteem & Confidence",
      "Body Image Concerns",
    ],
    probono: true,
  },

  "therapist-45": {
    id: "therapist-45",
    displayId: "Therapist 45",
    name: "Aparajita Basu Roy",
    pronouns: "she/her",
    avatar: "/images/team/roy-basu.jpg",
    qualifications: [
      {
        degree: "MSc. Neuropsychology",
        institution: "",
      },
      {
        degree: "Certified in Counselling & Therapy from Counsel India, ",
        institution: "",
      },
      {
        degree: " Suicide Prevention from Wesleyan University ",
        institution: "",
      },
      {
        degree: "Psychological First Aid from John Hopkins University",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Friday",
        hours: "7:30 AM to 10:30 PM",
      },
      {
        days: "Saturday - Sunday",
        hours: "11:00 AM to 5:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "Rs",
            duration: "50 mins",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "200",
          max: "1000",
        },
      },
      priceRange: "500-1000", // Chosen based on the majority of prices
      highestCharge: "900",
    },
    bio: `Hi, I’m Aparajita (she/her), a neuropsychologist with a Master’s degree, offering online therapy for adolescents and young adults navigating life. My practice is queer-affirmative, neurodivergence-affirmative, trauma-informed, and rooted in interpersonal and eclectic approaches—think structured, but with a splash of “let’s figure this out together."
\n
I’m here for the breakdowns, the breakthroughs, and every 'what even is this?' moment along the way. Expect a warm, judgment-free vibe, with occasional pop culture metaphors, anime references, or a music lyric or two sneaking into the conversation.`,
    experience: 1,
    experienceRange: "1-2 years",
    specialization: [
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Stress & Burnout",
      "Career & Academic Stress",
      "Neurodivergence",
    ],
    contact: {
      email: "thetherapistaparajita@gmail.com",
      phone: "+917486096959",
      location: "Noida , Online",
      linkedin: "http://www.linkedin.com/in/aparajita-basu-roy",
    },
    languages: ["English", "Hindi", "Bengali"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Stress & Burnout",
      "Career & Academic Stress",
      "Neurodivergence",
    ],
    directConcernsTags: [
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Stress & Burnout",
      "Career & Academic Stress",
      "Neurodivergence",
    ],
  },
  "therapist-46": {
    id: "therapist-46",
    displayId: "Therapist 46",
    name: "Jyoti",
    pronouns: "she/her",
    avatar: "/images/team/Jyoti.PNG",
    qualifications: [
      {
        degree: "M.Sc. Counseling Psychology ",
        institution: "",
      },
      {
        degree: "Certificate Course in Trauma informed approach",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Tuesday - Sunday",
        hours: "10:00 AM to 9:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1500",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "800",
          max: "1000",
        },
        availableFor: ["Available for Students and Non-Working professionals"],
      },
      priceRange: "1000-1500", // Chosen based on the majority of prices
      highestCharge: "1200",
    },
    bio: "Hi, I’m Jyoti —a counseling psychologist offering therapy through a trauma-informed and sex-positive lens. I draw from psychodynamic and relational approaches to help you explore the patterns, relationships, and parts of yourself that feel too much or hard to name. Therapy with me is deep, warm, occasionally spicy, and grounded in the belief that healing starts with getting better at feeling, not just feeling better.",
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Trauma",
      "Romantic Relationships",
      "Familial Relationships",
      "Identity Exploration",
      "Sexuality - related concerns",
    ],
    contact: {
      email: "thevelvetundertow@gmail.com",
      phone: "+918800734595 ",
      location: "Noida Ext., Online",
      linkedin:
        "https://www.linkedin.com/in/jyoti-d-926286213?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
      instagram:
        "https://www.instagram.com/thevelvetundertow?igsh=ZnhxbnlwYXRncG1l",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Romantic Relationships",
      "Familial Relationships",
      "Identity Exploration",
      "Sexuality - related concerns",
    ],
    directConcernsTags: [
      "Trauma",
      "Romantic Relationships",
      "Familial Relationships",
      "Identity Exploration",
      "Sexuality - related concerns",
    ],
    reviews: [
      {
        client: "",
        review:
          "Jyoti played a crucial role in helping me navigate both personal and professional challenges during a difficult period in my life, especially when the pressures from my workplace became overwhelming. Her support went beyond just listening—she guided me to look at situations from new perspectives, helping me reflect on my own patterns and grow from them. Through her empathy, insight, and encouragement, I began to understand more about myself, my relationships, and how to approach life with greater balance and clarity. Jyoti didn’t just help me cope—she helped me evolve, pushing me to embrace learning, self-awareness, and emotional resilience in ways that continue to shape my journey. ",
      },
      {
        client: "",
        review: `I started my sessions with Jyoti a couple of months ago and the journey has been truly transformative. From the very beginning, she created a safe and non-judgmental space that allowed me to open up and explore my thoughts and emotions freely. 
      \n 
       Through our sessions, she helped me identify my underlying fears and the specific trigger points that were affecting my emotional well-being. What stood out to me was her ability to guide me in understanding not just what I was feeling, but why. She provided the insights that enabled me to channel my energy more constructively and become more mindful and aware of my emotional patterns.
\n So far, this process has helped me a lot in managing my reactions and staying grounded, especially during challenging moments. I’m truly grateful for her support and highly recommend Jyoti to anyone seeking clarity, emotional healing and personal growth.`,
      },
      {
        client: "",
        review:
          "I started my therapy with Jyoti 3 months ago. I am so grateful for her as she has helped me become more confident person. I would recommend her to everyone in my network.",
      },
    ],
  },
  "therapist-47": {
    id: "therapist-47",
    displayId: "Therapist 47",
    name: "Vaishnavi Kowshik",
    pronouns: "she/her",
    avatar: "/images/team/vaishnavi-kowshik.jpeg",
    qualifications: [
      {
        degree: "MA in Psychology (Counselling)",
        institution: "",
      },
      {
        degree: "MSc in Cognitive Neuroscience",
        institution: "",
      },
      {
        degree: "Certification on DBT and EFIT techniques",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Friday",
        hours: "7 AM to 9 AM",
      },
      {
        days: "Monday - Friday",
        hours: "7 PM to 9 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1200",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "",
          max: "",
        },
      },
      priceRange: "1500-2000", // Chosen based on the majority of prices
      highestCharge: "1200",
    },
    bio: `Hi, I’m Vaishnavi, a counsellor with training in Counselling Psychology and Cognitive Neuroscience. I offer a warm, non-judgmental space where you can feel heard and supported.

\n    My approach is gentle, collaborative, and aimed towards you. I draw from person-centred therapy, CBT, and trauma-informed practices, guided by both science and empathy.
\n You don’t need to have it all figured out. Just come as you are — we’ll take it from there.`,
    experience: 2,
    experienceRange: "2-3 years",
    specialization: [
      "Trauma",
      "Romantic Relationships",
      "Anxiety & Overthinking",
      "Self-Esteem & Confidence",
      "Career & Academic Stress",
    ],
    contact: {
      email: "vaishnavirkowshik21@gmail.com",
      phone: "+18058646218",
      location: "Online",

      linkedin:
        "https://www.linkedin.com/in/vaishnavi-ramesh-kowshik-716171119/",
      instagram: "https://www.instagram.com/vaishnavirkowshik21/",
    },
    languages: ["English", "Kannada", "Tamil"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Romantic Relationships",
      "Anxiety & Overthinking",
      "Self-Esteem & Confidence",
      "Career & Academic Stress",
    ],
    directConcernsTags: [
      "Trauma",
      "Romantic Relationships",
      "Anxiety & Overthinking",
      "Self-Esteem & Confidence",
      "Career & Academic Stress",
    ],
  },

  "therapist-48": {
    id: "therapist-48",
    displayId: "Therapist 48",
    name: "Vridhika Sachdeva",
    pronouns: "she/her",
    avatar: "/images/team/vridhika.jpeg",
    qualifications: [
      {
        degree: "MSc. Clinical Psychology",
        institution: "",
      },
      {
        degree: "Certified Expressive Arts Based Therapist, ICPEM",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Saturday",
        hours: "11 AM to 6 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "799",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "499",
          max: "799",
        },
      },
      priceRange: "500-1000", // Chosen based on the majority of prices
      highestCharge: "799",
    },
    bio: `I work from a person-centred lens, rooted in the belief that people carry an inner capacity for growth, insight, and healing. My role is to walk alongside you—holding space with attentiveness, respect, and a deep trust in your unique process.

As a certified Expressive Arts-Based Therapist, I also bring creative mediums into the work, offering non-verbal ways to access and express what might feel difficult to articulate.`,
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Grief & Loss",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Identity Exploration",
      "Life Transitions",
    ],
    contact: {
      email: "therapywithvridhika@gmail.com",
      phone: "9650650883",
      location: "Delhi/Online",
      linkedin: "https://www.linkedin.com/in/vridhika-sachdeva-aa925827b/",
      instagram: "https://www.instagram.com/therapywithvridhika/",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Grief & Loss",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Identity Exploration",
      "Life Transitions",
    ],
    directConcernsTags: [
      "Grief & Loss",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Identity Exploration",
      "Life Transitions",
    ],
  },

  "therapist-49": {
    id: "therapist-49",
    displayId: "Therapist 49",
    name: "Gayatri Thakre",
    pronouns: "she/her",
    avatar: "/images/team/gayatri-thakre.jpg",
    qualifications: [
      {
        degree: "M.A. in Applied Psychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Saturday",
        hours: "5:30 PM to 9:30 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "upto",
          max: "700",
        },
        availableFor: ["Students"],
      },
      priceRange: "500-1000", // Chosen based on the majority of prices
      highestCharge: "1000",
    },
    bio: `I take an eclectic, trauma-informed approach, tailoring therapy to your unique needs. Drawing from CBT, DBT, Person-Centered, and Narrative Therapy, I help you understand patterns, build coping skills, and reconnect with your strengths. I value multicultural awareness and deeply respect how your background and identity shape your experience. You can expect a safe, warm, and respectful space where we grow together at your pace.`,
    experience: 1,
    experienceRange: "1-2 years",
    specialization: [
      "Trauma",
      "Romantic Relationships",
      "Familial Relationships",
      "Self-Esteem & Confidence",
      "Men's Mental health",
    ],
    contact: {
      email: "gayatri1.work@gmail.com",
      phone: "8087717072",
      location: "Nagpur / Online",
      linkedin:
        "https://www.linkedin.com/in/gayatri-thakre-343390193?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      instagram: "https://www.instagram.com/therapywithvridhika/",
    },
    languages: ["English", "Hindi", "Marathi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Romantic Relationships",
      "Familial Relationships",
      "Self-Esteem & Confidence",
      "Men's Mental health",
    ],
    directConcernsTags: [
      "Trauma",
      "Romantic Relationships",
      "Familial Relationships",
      "Self-Esteem & Confidence",
      "Men's Mental health",
    ],
  },

  "therapist-50": {
    id: "therapist-50",
    displayId: "Therapist 50",
    name: "Chhavi Bhingare",
    pronouns: "she/her",
    avatar: "/images/team/chhavi-bhingare.jpg",
    qualifications: [
      {
        degree: "Msc in Clinical Psychology ",
        institution: "",
      },
      {
        degree: "Diploma in Counseling psychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Sunday",
        hours: "9:00 AM to 11:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "800",
          max: "1000",
        },
        availableFor: ["Students"],
      },
      priceRange: "500-1000", // Chosen based on the majority of prices
      highestCharge: "1000",
    },
    bio: `The very first thing a client can expect is a connection with their therapist. A comfortable space where they can reveal who they are completely. And, then they can expect a therapeutic approach which can help them understand themselves better and live a life in a way they want to And when it comes to modalities particularly, I work with CBT, DBT, SFBT, and a few techniques from other therapuetic approaches as well. I understand my client and then I see what is the best out there which will be suitable for the client. `,
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Romantic Relationships",
      "Familial Relationships",
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
    ],
    contact: {
      email: "chhavi.psychology15@gmail.com ",
      phone: "9131027637",
      location: "Online",
      linkedin: "http://www.linkedin.com/in/chhavi-bhingare",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Romantic Relationships",
      "Familial Relationships",
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
    ],
    directConcernsTags: [
      "Romantic Relationships",
      "Familial Relationships",
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
    ],
  },

  "therapist-51": {
    id: "therapist-51",
    displayId: "Therapist 51",
    name: "Ishika Parekh",
    pronouns: "she/her",
    avatar: "/images/team/ishika-parekh.jpeg",
    qualifications: [
      {
        degree: "MA in Counseling Psychology",
        institution: "",
      },
      {
        degree: "Trauma Informed Care for CSA survivors",
        institution: "",
      },
      {
        degree:
          "Currently in Training for Level 1 & 2 of Gottman method of couples therapy",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Friday",
        hours: "10:00 AM to 5:00 PM",
      },
      {
        days: "Saturday",
        hours: "10:00 AM to 2:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "800-1200",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "600",
          max: "",
        },
        availableFor: ["Students"],
      },
      priceRange: "500-1000", // Chosen based on the majority of prices
      highestCharge: "1000",
    },
    bio: `Helping people make their world a better place
I incorporate the principles of humanistic therapies specifically Gestalt Therapy in my
practice with a extensive use of Behaviour Therapy, specifically Cognitive Behavioural
Therapy. I strive to create a supportive and non-judgemental space to help
individuals navigate emotional challenges, develop resilience, and achieve meaningful
change`,
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Romantic Relationships",
      "Familial Relationships",
      "Friendships & Peer Concerns",
      "Self-Esteem & Confidence",
      "Body Image Concerns",
    ],
    contact: {
      email: "ishika@thesabr.in",
      phone: "9167152406",
      location: "Online",
      instagram: "https://www.instagram.com/ishika.sabr/",
      linkedin: "http://www.linkedin.com/in/ishika-parekh-4baab51b9",
    },
    languages: ["English", "Hindi", "Gujrati"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Romantic Relationships",
      "Familial Relationships",
      "Friendships & Peer Concerns",
      "Self-Esteem & Confidence",
      "Body Image Concerns",
    ],
    directConcernsTags: [
      "Romantic Relationships",
      "Familial Relationships",
      "Friendships & Peer Concerns",
      "Self-Esteem & Confidence",
      "Body Image Concerns",
    ],
  },

  "therapist-52": {
    id: "therapist-52",
    displayId: "Therapist 52",
    name: "Aditi Ghatole",
    pronouns: "she/they",
    avatar: "/images/team/aditi-ghatole.jpg",
    qualifications: [
      {
        degree: "MA in Counselling Psychology ",
        institution: "",
      },
      {
        degree: "Certified Queer Affirmative Practioner, TA and REBT",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Saturday",
        hours: "12:00 PM to &:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "2500",
            currency: "Rs",
          },
          couples: {
            amount: "4000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "",
          max: "NA",
        },
      },
      priceRange: "500-1000", // Chosen based on the majority of prices
      highestCharge: "1000",
    },
    bio: `My goal as a therapist is to create a space where clients feel completely seen, heard, and equal. I believe healing thrives in an environment of openness, and I often bring humor and lightness to our sessions, making space for both depth and levity.
I also recognize that the therapeutic space is a reflection of the broader realities that clients bring with them—political, social, and economic. Affirming a client's full identity, beyond just mental or emotional health, is an integral part of my work.`,
    experience: 6,
    experienceRange: "4+ years",
    specialization: [
      "Trauma",
      "Grief & Loss",
      "Stress & Burnout",
      "Gender Identity  - related concerns",
      "Neurodivergence",
    ],
    contact: {
      email: "Aditigha@gmail.com",
      phone: "9137303727",
      location: "Andheri, Mumbai / Online",
      linkedin:
        "https://www.linkedin.com/in/aditighatole1608?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    },
    languages: ["English", "Hindi", "Marathi"],
    serviceIds: ["individual-therapy", "couples-therapy"],
    concerns: [
      "Trauma",
      "Grief & Loss",
      "Stress & Burnout",
      "Gender Identity  - related concerns",
      "Neurodivergence",
    ],
    directConcernsTags: [
      "Trauma",
      "Grief & Loss",
      "Stress & Burnout",
      "Gender Identity  - related concerns",
      "Neurodivergence",
    ],
  },

  "therapist-53": {
    id: "therapist-53",
    displayId: "Therapist 53",
    name: "Shagun Raghuwanshi",
    pronouns: "she/her",
    avatar: "/images/team/shagun.jpg",
    qualifications: [
      {
        degree: "MSC in Clinical Psychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Friday",
        hours: "10:00 AM to & 5:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "400",
          max: "600",
        },
      },
      priceRange: "500-1000", // Chosen based on the majority of prices
      highestCharge: "1000",
    },
    bio: `I'm here to support you on your journey, hoping to create a warm, safe space where you feel comfortable to explore your thoughts and feelings freely. I follow a person centered and humanistic approach - which basically means understanding your world from your viewpoint. Together we find ways to navigate challenges and uncover the strengths you already carry. You can expect me to listen, understand your experience, and walk alongside you every step of the way. Let's hold space for your struggles and for YOU. `,
    experience: 1,
    experienceRange: "1-2 years",
    specialization: [
      "Anxiety & Overthinking",
      "Stress & Burnout",
      "Extreme Moods",
      "Identity Exploration",
      "Life Transitions",
    ],
    contact: {
      email: "shagunraghuwanshi3691@gmail.com",
      phone: "9928455159",
      location: "Online",
      linkedin: "https://www.linkedin.com/in/shagun-raghuwanshi-62448021b",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Anxiety & Overthinking",
      "Stress & Burnout",
      "Extreme Moods",
      "Identity Exploration",
      "Life Transitions",
    ],
    directConcernsTags: [
      "Anxiety & Overthinking",
      "Stress & Burnout",
      "Extreme Moods",
      "Identity Exploration",
      "Life Transitions",
    ],
    reviews: [
      {
        client: "",
        review: `Working with you is honestly helping me more than I expected. You make it a bit easier to open up without feeling judged, and our sessions have given me a lot of clarity (and sanity lol). I feel like I’m starting to understand myself better, and a lot of that is thanks to how you ask the questions. So yeah… grateful for you!" - Saahiti  "Taking sessions with Ms Shagun has really helped me understand myself better. Even when I don’t know exactly how to say something or frame what I’m feeling, she encourages me to just blurt it out as in whichever words that come to my head anyway. She listens patiently, tries to make sense of it, and then checks with me if that’s what I meant. That kind of space where I don’t have to say things perfectly, that makes it so much easier to open up. She asks the kind of questions that make me think more deeply about what I’m saying and feeling, and that’s helped me have a lot of realisations I might not have reached on my own. She explains things in such a way that makes it very clear to me, even if I don’t understand things at times, she tries to explain so patiently until I clearly understand. I never feel judged or rushed in our sessions. There’s always a safe vibe where I feel comfortable talking about different things" - Nandhini "It was my first therapy experience. I was nervous initially and have heard that it takes time to figure out who is the right therapist for you. But I am glad that I found the right therapist for me the first time only. I have had so many realisations in my therapy sessions. I felt heard and safe to express myself fully. I myself am a psychology student so I learned a lot too. I am really grateful to have found u as my therapist.`,
      },
    ],
  },

  "therapist-54": {
    id: "therapist-54",
    displayId: "Therapist 54",
    name: "Amritha VR",
    pronouns: "she/her/they/them",
    avatar: "/images/team/amritha-vr.jpg",
    qualifications: [
      {
        degree: "MSc. Psychology",
        institution: "",
      },
      {
        degree:
          "Diploma in Community Mental Health, Trauma-Informed Somatic Therapy, Adolescent Problem Solving",
        institution: "",
      },
      {
        degree:
          "Advanced Diploma in Trauma Informed Psychosocial Guidance and Gounseling",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday, Tuesday, Thursday, Friday",
        hours: "10:00 AM to & 7:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "850",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "500",
          max: "700",
        },
        availableFor: [
          "500 onwards for Students and Individuals from Tamil Eelam",
        ],
      },
      priceRange: "500-1000", // Chosen based on the majority of prices
      highestCharge: "1000",
    },
    bio: `Therapy, to me, is a collaborative journey—I’ll walk alongside you. As a person with multitudes of expression of my social identities, I’m committed to creating affirming spaces where you feel safe, seen, and free to be your authentic self. My approach blends gestalt and humanistic traditions, focusing on you as a whole person, your stories and lived experiences. I deeply value presence and believe our work can help you move through life with confidence, resilience, and clarity. I also draw from CBT and use a trauma-informed lens to honour your pace and experience. I look forward to meeting you—just as you are.  I sincerely value social justice, and am open to un-learning and re-learning from you, while also showing up for you in our therapeutic space in our collaborative journey! `,
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Self-Esteem & Confidence",
      "Body Image Concerns",
      "Career & Academic Stress",
    ],
    contact: {
      email: "unaarvugal.withamri@gmail.com",
      phone: "",
      location: "Online",
      linkedin:
        "https://www.linkedin.com/in/amritha-vr-b74615239?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      instagram:
        "https://www.instagram.com/unaarvugal/?utm_source=qr&igsh=MTczeTU3NXFrem40MA%3D%3D#",
    },
    languages: ["English", "Tamil", "Malayalam"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Self-Esteem & Confidence",
      "Body Image Concerns",
      "Career & Academic Stress",
    ],
    directConcernsTags: [
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Self-Esteem & Confidence",
      "Body Image Concerns",
      "Career & Academic Stress",
    ],
  },

  "therapist-55": {
    id: "therapist-55",
    displayId: "Therapist 55",
    name: "Mythri",
    pronouns: "she/her ",
    avatar: "/images/team/mythri.jpg",
    qualifications: [
      {
        degree: "MSc Counselling Psychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Friday",
        hours: "12:00 PM to  7:00 PM",
      },
      {
        days: "Saturday",
        hours: "12:00 PM ton 3:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "600",
          max: "1000",
        },
      },
      priceRange: "500-1000", // Chosen based on the majority of prices
      highestCharge: "1000",
    },
    bio: `While my core is humanistic, I follow an eclectic approach. Because I believe therapy is never one-shoe-fits-all. I draw from Gestalt Therapy when there’s a need to connect more deeply to the here-and-now experience, and from Narrative Therapy when we explore the stories you’ve been told, or have told yourself about who you are. Together we create a space which is safe, reflective, warm and genuine. I will be your fellow traveler as we navigate through your feelings, thoughts and actions.`,
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Familial Relationships",
      "Friendships & Peer Concerns",
      "Career & Academic Stress",
      "Neurodivergence",
      "Addiction & Coping Behaviors",
    ],
    contact: {
      email: "mythri.bagulakoti1310@gmail.com",
      phone: "+91 6305353382",
      location: "Hyderabad, Telangana / Online",
      linkedin:
        "https://www.linkedin.com/in/amritha-vr-b74615239?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
      instagram:
        "https://www.instagram.com/unaarvugal/?utm_source=qr&igsh=MTczeTU3NXFrem40MA%3D%3D#",
    },
    languages: ["English", "Telugu", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Familial Relationships",
      "Friendships & Peer Concerns",
      "Career & Academic Stress",
      "Neurodivergence",
      "Addiction & Coping Behaviors",
    ],
    directConcernsTags: [
      "Familial Relationships",
      "Friendships & Peer Concerns",
      "Career & Academic Stress",
      "Neurodivergence",
      "Addiction & Coping Behaviors",
    ],
  },
  "therapist-56": {
    id: "therapist-56",
    displayId: "Therapist 56",
    name: "Manasi Gujarathi",
    pronouns: "she/her ",
    avatar: "/images/team/gujrathi.jpg",
    qualifications: [
      {
        degree: "MA in Clinical Psychology",
        institution: "",
      },
      {
        degree: "Practicing Play Therapist",
        institution: "",
      },
      {
        degree: "Art Based Therapy",
        institution: "",
      },
      {
        degree: "CBT Practitioner Course",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Friday",
        hours: "5:30 PM to  8:30 PM",
      },
      {
        days: "Saturday",
        hours: "6:00 PM to 8:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1200",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "800",
          max: "900",
        },
      },
      priceRange: "1000-1500", // Chosen based on the majority of prices
      highestCharge: "1200",
    },
    bio: `I work with children, adolescents, and adults up to the age of 35. For adolescents and adults, I use an eclectic approach focusing on person-centered therapy, Art-Based Therapy, and Cognitive Behavioral Therapy (CBT). 
For children, I mostly use play therapy as it allows them to express through a medium comfortable for them- Play. 
For me, the most important part of the therapeutic relationship is providing a space that feels safe enough to bring in insecurities, vulnerabilities, or inner turmoil. I aim to keep the space inclusive, and aligned with client’s lived experience.`,
    experience: 2,
    experienceRange: "2-3 years",
    specialization: [
      "Trauma",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Stress & Burnout",
      "Neurodivergence",
    ],
    contact: {
      email: "bloomstrongercounselling@gmail.com",
      phone: "+91 9921851065",
      location: "Pune / Online",
      linkedin: "http://www.linkedin.com/in/manasi-gujarathi-ab76131b9",
      instagram:
        "https://www.instagram.com/bloom.stronger_counselling?igsh=MWl5MXA2OGZ1aXpnNQ==",
    },
    languages: ["English", "Marathi", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Stress & Burnout",
      "Neurodivergence",
    ],
    directConcernsTags: [
      "Trauma",
      "Anxiety & Overthinking",
      "Depression & Low Mood",
      "Stress & Burnout",
      "Neurodivergence",
    ],
  },

  "therapist-57": {
    id: "therapist-57",
    displayId: "Therapist 57",
    name: "Manasvi Azad",
    pronouns: "she/her ",
    avatar: "/images/team/manasvi-azad.jpg",
    qualifications: [
      {
        degree: "M.Sc. Applied Psychology (Clinical Specialization) ",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Friday",
        hours: "10:00 AM to  5:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "700",
          max: "-",
        },
        availableFor: ["Students"],
      },
      priceRange: "1000-1500", // Chosen based on the majority of prices
      highestCharge: "1200",
    },
    bio: `My approach is rooted in the belief that people don’t need fixing, they need space to reconnect with themselves. I work from a trauma-informed, relational lens, attuning to your emotions, body, and relationships. Blending person-centered, somatic, and mindfulness-based methods, I offer a space of curiosity, not judgment. Therapy with me isn’t about quick fixes, but a steady, safe relationship where even your defenses and silences are welcome`,
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Trauma",
      "Romantic Relationships",
      "Anxiety & Overthinking",
      "Self-Esteem & Confidence",
      "Sexuality - related concerns",
    ],
    contact: {
      email: "therapy.manasvi@gmail.com",
      phone: "+919004327095",
      location: "Gurgaon, Delhi NCR / Online",
      linkedin: "https://www.linkedin.com/in/manasvi-azad-a2ab61211/",
      instagram: "https://www.instagram.com/p/DKtGTgYJ7aV/?img_index=1",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Trauma",
      "Romantic Relationships",
      "Anxiety & Overthinking",
      "Self-Esteem & Confidence",
      "Sexuality - related concerns",
    ],
    directConcernsTags: [
      "Trauma",
      "Romantic Relationships",
      "Anxiety & Overthinking",
      "Self-Esteem & Confidence",
      "Sexuality - related concerns",
    ],
  },

  "therapist-58": {
    id: "therapist-58",
    displayId: "Therapist 58",
    name: "Mishti Kapoor",
    pronouns: "she/her ",
    avatar: "/images/team/misthi-kapoor.jpg",
    qualifications: [
      {
        degree: "MA Counselling Psychology",
        institution: "",
      },
    ],
    availability: [
      {
        days: "Monday - Friday",
        hours: "2:00 PM to  5:00 PM",
      },
      {
        days: "Monday - Friday",
        hours: "8:00 PM to  9:00 PM",
      },
    ],
    pricing: {
      standardFees: [
        {
          individual: {
            amount: "1000",
            currency: "Rs",
          },
        },
      ],
      slidingScale: {
        range: {
          min: "800",
          max: "-",
        },
        availableFor: ["Students"],
      },
      priceRange: "1000-1500", // Chosen based on the majority of prices
      highestCharge: "1200",
    },
    bio: `Hello and welcome! My name is Mishti Kapoor, a Counselling Psychologist whose practice is deeply rooted in making your therapeutic space feel compassionate and accepting. I draw from the ideals of Client-Centered and Psychodynamic approaches, with the belief that your journey should be tailored according to your own, distinct needs. Together, we can work on concerns ranging from self esteem/confidence building, stress and anxiety, to social and relationship issues. We will focus on recognizing your unique perspectives and strengths, aimed at helping you reach towards your most empowered self.`,
    experience: 1,
    experienceRange: "Less than 1 year",
    specialization: [
      "Romantic Relationships",
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Self-Esteem & Confidence",
      "Body Image Concerns",
    ],
    contact: {
      email: "mishtikapoor.2001@gmail.com",
      phone: "+919953964426",
      location: " Delhi / Online",
      linkedin: "http://www.linkedin.com/in/mishtikapoor11",
      instagram:
        "https://www.instagram.com/_mishtikapoor?igsh=ZGd6emN6b3Y0ajgw",
    },
    languages: ["English", "Hindi"],
    serviceIds: ["individual-therapy"],
    concerns: [
      "Romantic Relationships",
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Self-Esteem & Confidence",
      "Body Image Concerns",
    ],
    directConcernsTags: [
      "Romantic Relationships",
      "Friendships & Peer Concerns",
      "Anxiety & Overthinking",
      "Self-Esteem & Confidence",
      "Body Image Concerns",
    ],
  },
};

// Services Data Store
export const SERVICES: Record<string, Service> = {
  "individual-therapy": {
    id: "individual-therapy",
    slug: "individual-therapy",
    name: "Individual Therapy",
    description:
      "Personalized one-on-one therapy sessions focusing on personal growth and mental well-being",
    targetAudience: ["Adults", "Teenagers"],
    duration: "45-60 minutes",
    sessionsPerMonth: "2-4",
    procedures: [
      {
        step: 1,
        description: "Initial assessment",
        duration: "30 minutes",
      },
      {
        step: 2,
        description: "Personal challenges exploration",
        duration: "20-30 minutes",
      },
    ],
    therapistIds: ["therapist-1", "therapist-2", "therapist-3"],
    pricing: {
      basePrice: 1500,
      currency: "Rs",
    },
    heroImage: "/images/individual-therapy.jpg",
  },
  "couples-therapy": {
    id: "couples-therapy",
    slug: "couples-therapy",
    name: "Couples Therapy",
    description:
      "Comprehensive relationship counseling to improve communication and strengthen emotional bonds",
    targetAudience: ["Married Couples", "Partners"],
    duration: "45-60 minutes",
    sessionsPerMonth: "2-4",
    procedures: [
      {
        step: 1,
        description: "Relationship assessment",
        duration: "30 minutes",
      },
    ],
    therapistIds: ["therapist-13", "therapist-14", "therapist-15"],
    pricing: {
      basePrice: 1500,
      currency: "Rs",
    },
    heroImage: "/images/couple-therapy.jpg",
  },

  "family-therapy": {
    id: "family-therapy",
    slug: "family-therapy",
    name: "Family Therapy",
    description:
      "Supportive group sessions designed to create a safe space for shared experiences and mutual healing",
    targetAudience: ["Families", "Parents with Children"],
    duration: "45-60 minutes",
    sessionsPerMonth: "2-4",
    procedures: [
      {
        step: 1,
        description: "Family dynamics assessment",
        duration: "30 minutes",
      },
      {
        step: 2,
        description: "Communication patterns exploration",
        duration: "30 minutes",
      },
      {
        step: 3,
        description: "Conflict resolution strategies",
        duration: "30 minutes",
      },
      {
        step: 4,
        description: "Family goal setting",
        duration: "20 minutes",
      },
    ],
    therapistIds: ["therapist-3", "therapist-4", "therapist-1"],
    pricing: {
      basePrice: 2000,
      currency: "Rs",
    },
    heroImage: "/images/family-therapy-1.jpg",
  },
};

export const getTherapistsByPriceRange = (
  priceRange: TherapistPricing["priceRange"]
): Therapist[] => {
  return Object.values(THERAPISTS).filter((therapist) => {
    const pricing = therapist.pricing;

    // If the therapist has priceRange set directly, use that
    if (pricing.priceRange === priceRange) {
      return true;
    }

    // Since standardFees is now an array, we need to find the highest charge
    // across all fee options
    let highestCharge = 0;

    // Check all standardFees entries for the highest charge
    pricing.standardFees.forEach((fee) => {
      // Check individual fees
      if (fee.individual?.amount) {
        const amount = parseInt(fee.individual.amount);
        highestCharge = Math.max(highestCharge, amount);
      }

      // Check couples fees
      if (fee.couples?.amount) {
        const amount = parseInt(fee.couples.amount);
        highestCharge = Math.max(highestCharge, amount);
      }
    });

    // If we have highestCharge field directly, use that instead
    if (pricing.highestCharge) {
      highestCharge = parseInt(pricing.highestCharge);
    }

    // Match the price range
    if (priceRange === "0-500") return highestCharge <= 500;
    if (priceRange === "500-1000")
      return highestCharge > 500 && highestCharge <= 1000;
    if (priceRange === "1000-1500")
      return highestCharge > 1000 && highestCharge <= 1500;
    if (priceRange === "1500-2000")
      return highestCharge > 1500 && highestCharge <= 2000;
    if (priceRange === "2000+") return highestCharge > 2000;

    return false;
  });
};

export const getTherapistsByExperience = (
  experienceRange: Therapist["experienceRange"]
): Therapist[] => {
  return Object.values(THERAPISTS).filter((therapist) => {
    // Use the therapist's experienceRange directly as it's always set
    return therapist.experienceRange === experienceRange;
  });
};

export const getTherapistsByConcern = (concern: string): Therapist[] => {
  return Object.values(THERAPISTS).filter((therapist) => {
    // If the therapist has concerns array, check if the concern is included
    if ("concerns" in therapist && Array.isArray(therapist.concerns)) {
      return therapist.concerns.includes(concern);
    }

    // Otherwise, check if it's in specialization
    return therapist.specialization.some((spec) =>
      spec.toLowerCase().includes(concern.toLowerCase())
    );
  });
};

export const getTherapistsByLanguage = (language: string): Therapist[] => {
  return Object.values(THERAPISTS).filter((therapist) =>
    therapist.languages.some(
      (lang) => lang.toLowerCase() === language.toLowerCase()
    )
  );
};

export const getProbonoTherapists = (probono: boolean): Therapist[] => {
  // If you're using a global therapists array
  return Object.values(THERAPISTS).filter(
    (therapist) => therapist.probono === true
  );
};

export const getAllConcerns = (): string[] => {
  const concernsSet = new Set<string>();

  // Collect from concerns field
  Object.values(THERAPISTS).forEach((therapist) => {
    if ("concerns" in therapist && Array.isArray(therapist.concerns)) {
      therapist.concerns.forEach((concern) => concernsSet.add(concern));
    }
  });

  // Collect from specialization field
  Object.values(THERAPISTS).forEach((therapist) => {
    therapist.specialization.forEach((spec) => concernsSet.add(spec));
  });

  return Array.from(concernsSet).sort();
};

export const getAllLanguages = (): string[] => {
  const languagesSet = new Set<string>();

  Object.values(THERAPISTS).forEach((therapist) => {
    therapist.languages.forEach((lang) => languagesSet.add(lang));
  });

  return Array.from(languagesSet).sort();
};

export const getServiceById = (id: string): Service | undefined => {
  return SERVICES[id];
};

export const getServiceBySlug = (slug: string): Service | undefined => {
  return Object.values(SERVICES).find((service) => service.slug === slug);
};

export const getTherapistById = (id: string): Therapist | undefined => {
  return THERAPISTS[id];
};

export const getTherapistsForService = (serviceId: string): Therapist[] => {
  const service = SERVICES[serviceId];
  if (!service) return [];
  return service.therapistIds
    .map((id) => THERAPISTS[id])
    .filter((therapist): therapist is Therapist => therapist !== undefined);
};

export const getServicesForTherapist = (therapistId: string): Service[] => {
  const therapist = THERAPISTS[therapistId];
  if (!therapist) return [];
  return therapist.serviceIds
    .map((id) => SERVICES[id])
    .filter((service): service is Service => service !== undefined);
};
